import b, { z as r } from "zod";
import { H as T, a as Ye, u as p, N as _t, c as Ie, C as At, A as F, i as dn, b as un, n as vt, d as hn, e as fn, f as mn, g as pn, s as v, h as N, j as Je, k as gn, S as bn, l as Xe, M as Ze, m as yn, o as Sn, B as Qe, p as ie, q as ce, r as y, t as wn, v as Pe, w as X, x as Fe, E as It, y as Tn, z as Se, D as _n, F as An, G as vn } from "./schema-DXOmILiJ.mjs";
import { av as $c, aW as Mc, aY as Gc, aX as zc, aZ as Wc, aa as Kc, ai as qc, _ as Yc, a2 as Jc, aQ as Xc, aR as Zc, aM as Qc, aL as el, aE as tl, aB as nl, aC as al, aD as rl, a_ as sl, aS as ol, I as il, O as cl, K as ll, a5 as dl, ak as ul, af as hl, aq as fl, aV as ml, W as pl, Q as gl, Y as bl, a1 as yl, as as Sl, ar as wl, ao as Tl, a8 as _l, a6 as Al, a7 as vl, Z as Il, ah as El, ad as Cl, a4 as Nl, X as xl, aG as kl, aF as Ol, aI as Pl, aJ as Fl, ac as Bl, ab as Rl, J as Dl, aH as jl, aT as Ul, aO as Ll, a$ as Hl, aN as Vl, aj as $l, ae as Ml, T as Gl, aP as zl, aU as Wl, b0 as Kl, a9 as ql, ap as Yl, R as Jl, U as Xl, V as Zl, $ as Ql, a3 as ed, a0 as td, am as nd, an as ad, al as rd, aK as sd, L as od, ag as id, P as cd, ax as ld, aw as dd, at as ud, ay as hd, au as fd, az as md, aA as pd } from "./schema-DXOmILiJ.mjs";
import { constants as S, starknetId as Et, CallData as O, CairoOption as et, CairoOptionVariant as tt, hash as Z, num as f, encode as Ee, uint256 as x, isSierra as In, TransactionType as nt } from "starknet";
import { isFunction as q, isString as Be, upperCase as Re, isNil as En, upperFirst as Cn, lowerCase as Ct, isUndefined as Nn, isEmpty as Ce, isArray as xn } from "lodash-es";
import { useEffect as Q, useMemo as R, useCallback as Nt, useRef as at, useState as kn } from "react";
import le, { useSWRConfig as On } from "swr";
import { hex as xt, base58 as kt } from "@scure/base";
import Pn from "object-hash";
import { validateMnemonic as Fn } from "@scure/bip39";
import { wordlist as Bn } from "@scure/bip39/wordlists/english";
import { UAParser as Rn } from "ua-parser-js";
const Dn = r.enum(["mainnet-alpha", "sepolia-alpha"]), jn = r.enum(["mainnet", "sepolia"]);
function jo(e) {
  return Dn.safeParse(e).success;
}
function Uo(e) {
  return jn.safeParse(e).success;
}
const Un = r.object({
  name: r.string().optional(),
  address: r.string(),
  ownerAddress: r.string(),
  chain: r.enum(["ethereum", "zksync", "zksync2", "starknet"]),
  deploymentStatus: r.enum([
    "notDeployed",
    "deploying",
    "deployed",
    "deployError"
  ]),
  application: r.enum(["mobile", "webwallet", "argentx"]),
  guardianAddresses: r.array(r.string()).optional(),
  enabledGuardianAddresses: r.array(r.string()).optional(),
  implClassHash: r.string().optional(),
  proxyClassHash: r.string().optional(),
  salt: r.string().optional(),
  created: r.string().optional(),
  contractVersion: r.string().optional(),
  contractName: r.string().optional(),
  version: r.number().optional(),
  owner: r.object({
    guid: r.string().optional(),
    signerType: r.enum(["StarknetKey", "EthereumKey"]).optional()
  }).optional()
}), Lo = r.object({
  address: r.string(),
  guardianAddress: r.string().optional(),
  account: Un
}), Ho = r.object({
  ownerAddress: r.string(),
  signature: r.object({
    r: r.string(),
    s: r.string()
  }),
  implClassHash: r.string().optional(),
  name: r.string().optional(),
  icon: r.string().optional()
});
function Vo(e) {
  return "transactionVersion" in e;
}
function $o(e) {
  return "simulateTransaction" in e;
}
function Mo(e) {
  return !("simulateTransaction" in e);
}
const Ln = r.object({
  value: r.string(),
  platform: r.enum(["ios", "argentx", "android", "webwallet"]).nullable()
}), Go = r.object({
  preferences: r.record(Ln)
});
class zo {
  constructor(t, n) {
    this.httpService = t, this.baseUrl = n, this.offsetInS = 0, this.syncIntervalInMs = 60 * 1e3, this.initialSync = this.syncWithServer(), setInterval(() => void this.syncWithServer(), this.syncIntervalInMs);
  }
  async now() {
    return await this.initialSync, new Date(Date.now() + this.offsetInS * 1e3);
  }
  async syncWithServer() {
    if (typeof window > "u")
      return;
    const { time: t } = await this.httpService.get(`${this.baseUrl}/time`), n = Math.floor(Date.now() / 1e3), a = t - n;
    this.offsetInS = a;
  }
}
class De {
  constructor(t, n = "json") {
    this.requestInit = t, this.responseType = n;
  }
  async get(t, n) {
    const a = q(this.requestInit) ? await this.requestInit() : this.requestInit, s = {
      ...a,
      ...n,
      method: "GET",
      // merge headers
      headers: {
        ...a == null ? void 0 : a.headers,
        ...n == null ? void 0 : n.headers
      }
    }, o = await fetch(t, s).catch(() => {
      throw new T(Ye.FAILED_TO_FETCH_URL, 0);
    });
    if (this.responseType === "json") {
      if (!o.ok)
        throw new T(o.statusText, o.status);
      return await o.json();
    }
    return o;
  }
  async post(t, n, a) {
    const s = q(this.requestInit) ? await this.requestInit() : this.requestInit, o = {
      ...s,
      ...n,
      method: "POST",
      // merge headers
      headers: {
        ...s == null ? void 0 : s.headers,
        ...n == null ? void 0 : n.headers
      }
    }, i = await fetch(t, o).catch(() => {
      throw new T(Ye.FAILED_TO_POST_URL, 0);
    });
    if (!i.ok)
      throw new T(i.statusText, i.status, await i.json());
    const c = await i.json();
    if (a)
      try {
        return a.parse(c);
      } catch (l) {
        throw new T(l.message, 0);
      }
    return c;
  }
  async put(t, n) {
    const a = q(this.requestInit) ? await this.requestInit() : this.requestInit, s = {
      ...a,
      ...n,
      method: "PUT",
      // merge headers
      headers: {
        ...a == null ? void 0 : a.headers,
        ...n == null ? void 0 : n.headers
      }
    }, o = await fetch(t, s).catch(() => {
      throw new T("Failed to put url", 0);
    });
    if (!o.ok)
      throw new T(o.statusText, o.status);
    return await o.json();
  }
  async delete(t, n) {
    const a = q(this.requestInit) ? await this.requestInit() : this.requestInit, s = {
      ...a,
      ...n,
      method: "DELETE",
      // merge headers
      headers: {
        ...a == null ? void 0 : a.headers,
        ...n == null ? void 0 : n.headers
      }
    }, o = await fetch(t, s).catch(() => {
      throw new T("Failed to delete url", 0);
    });
    if (!o.ok)
      throw new T(o.statusText, o.status);
  }
}
const Y = (e) => {
  process.env.NODE_ENV;
};
function Hn(e, t) {
  const n = e.clone(), a = new Headers(n.headers);
  for (const [s, o] of Object.entries(t))
    a.set(s, o);
  return new Response(n.body, {
    status: n.status,
    statusText: e.statusText,
    headers: a
  });
}
class Wo {
  constructor(t, n, a, s) {
    this.dateService = t, this.cacheService = n, this.httpService = a, this.options = s, this.inFlightRequests = /* @__PURE__ */ new Map();
  }
  async rawGet(t, n) {
    try {
      const a = await this.cacheService.get(t), s = await this.dateService.now(), o = new Date(a.headers.get("date") || ""), i = s.getTime() - o.getTime();
      if (i < this.options.freshFor)
        return Y("🟢 [SWR] Using fresh cache"), a;
      if (i < this.options.staleFor)
        return this.fetchAndCache(t, n), Y("🟠 [SWR] Revalidating cache"), a;
      throw new Error("Cache too old");
    } catch (a) {
      if (a instanceof T)
        throw a;
      return Y(), await this.fetchAndCache(t, n);
    }
  }
  async get(t, n) {
    const a = await this.rawGet(t, n);
    return this.parseResponse(a);
  }
  async fetchAndCache(t, n) {
    const a = this.inFlightRequests.get(t);
    if (!a) {
      const s = this.httpService.get(t, n).then(async (o) => {
        const i = await this.dateService.now();
        return await this.cacheService.set(t, Hn(o, {
          date: i.toUTCString()
        })), o;
      }).finally(() => {
        this.inFlightRequests.delete(t);
      });
      return this.inFlightRequests.set(t, s), s;
    }
    return Y(), a;
  }
  parseResponse(t) {
    if (t.ok)
      return t.json();
    throw new T(t.statusText, t.status);
  }
}
const ee = (e, t, n) => {
  const a = new Error(e);
  a.name = "FetcherError", a.url = t.url, a.status = t.status, a.statusText = t.statusText, a.responseText = n;
  try {
    const s = JSON.parse(n);
    a.responseJson = s;
  } catch {
  }
  return a;
}, Ot = async (e, t) => {
  const n = await fetch(e, t), a = await n.text();
  if (!n.ok)
    throw ee("An error occurred while fetching", n, a);
  try {
    return JSON.parse(a);
  } catch {
    throw ee("An error occurred while parsing", n, a);
  }
}, Ko = async (e, t) => {
  const n = await fetch(e, {
    method: "POST",
    ...t
  }), a = await n.text();
  if (!n.ok)
    throw ee("An error occurred while fetching", n, a);
  try {
    return JSON.parse(a);
  } catch {
    throw ee("An error occurred while parsing", n, a);
  }
}, qo = (e) => ({
  refreshInterval: e,
  dedupingInterval: e
}), Yo = (e) => `${e.networkId}::${e.address}`, Vn = () => {
};
function $n(e, t, n, a) {
  const { cache: s } = On(), o = le(e && t, e ? n : Vn, a);
  return Q(() => {
    e || (o.mutate(), s.delete(t));
  }, [e]), o;
}
const Jo = {
  revalidateOnFocus: !1,
  revalidateOnMount: !0,
  revalidateOnReconnect: !1,
  refreshWhenOffline: !1,
  refreshWhenHidden: !1,
  refreshInterval: 0
}, Mn = async (e, t) => {
  try {
    const { time: n } = await Ot(p(e, "time"), {
      headers: t
    });
    return n;
  } catch {
    throw new Error("failed to request time");
  }
}, Xo = async (e, t) => {
  const n = await Mn(e, t);
  return Math.floor(n);
};
function Gn(e) {
  switch (e) {
    case "mainnet-alpha":
    case S.NetworkName.SN_MAIN:
      return S.StarknetChainId.SN_MAIN;
    case "sepolia-alpha":
    case S.NetworkName.SN_SEPOLIA:
      return S.StarknetChainId.SN_SEPOLIA;
    default:
      throw new _t({
        code: "NOT_FOUND",
        message: `Unknown networkId: ${e}`
      });
  }
}
function zn(e) {
  return e.replace(".stark", "").split(".").map((a) => Et.useEncoded(a).toString(10));
}
function Wn(e) {
  const t = Gn(e);
  return Et.getStarknetIdContract(t);
}
function Kn(e, t) {
  const n = Wn(t), a = zn(e);
  try {
    const o = { domain: a, hint: [] };
    return Ie.parse({
      contractAddress: n,
      entrypoint: "domain_to_address",
      calldata: o
    });
  } catch (s) {
    throw new At({
      code: "NOT_VALID",
      options: { error: s }
    });
  }
}
async function qn(e, t, n) {
  if (!t || !n)
    throw new _t({
      code: "NO_NETWORK_OR_MULTICALL"
    });
  let a = null;
  try {
    a = Kn(e, t);
  } catch (c) {
    throw new At({
      code: "NOT_VALID",
      options: { error: c }
    });
  }
  let s, o;
  try {
    s = await n.callContract(a), o = s[0];
  } catch {
    throw new F({
      code: "STARKNAME_ERROR"
    });
  }
  if (dn(o))
    throw new F({
      code: "STARKNAME_NOT_FOUND",
      message: `${e} not found`
    });
  if (!un(o))
    throw new F({
      code: "STARKNAME_INVALID_ADDRESS",
      message: `${e} resolved to an invalid address (${o})`
    });
  return vt(o);
}
class Zo {
  constructor(t, n, a) {
    this.httpService = t, this.baseUrl = n, this.allowedArgentNameNetworkId = a;
  }
  async parseAddressOrDomain(t, n, a) {
    if (hn(t))
      return vt(t);
    try {
      return await this.getAddressFromDomainName(t, n, a);
    } catch {
      throw new F({ code: "NOT_VALID" });
    }
  }
  async getAddressFromDomainName(t, n, a) {
    if (fn(t))
      return qn(t, n, a);
    if (mn(t)) {
      if (n !== this.allowedArgentNameNetworkId)
        throw new F({
          code: "ARGENT_NAME_INVALID_NETWORK",
          message: `Argent name is only enabled on "${this.allowedArgentNameNetworkId}"`
        });
      return pn(t, this.httpService, this.baseUrl);
    }
    throw new F({
      code: "NO_ADDRESS_FROM_DOMAIN"
    });
  }
}
const Yn = [
  "0x25ec026985a3bf9d0cc1fe17326b245dfdc3ff89b8fde106542a3ea56c5a918"
], I = {
  // CAIRO_0
  // NOTE: 0.2.4 is actually defined as 0.2.3.1 but it's not supported by semver
  "0.2.4": "0x033434ad846cdd5f23eb73ff09fe6fddd568284a0fb7d1be20ee482f044dabe2",
  "0.2.3": "0x1a7820094feaf82d53f53f214b81292d717e7bb9a92bb2488092cd306f3993f",
  "0.2.2": "0x3e327de1c40540b98d05cbcb13552008e36f0ec8d61d46956d2f9752c294328",
  "0.2.1": "0x7e28fb0161d10d1cf7fe1f13e7ca57bce062731a3bd04494dfd2d0412699727",
  // CAIRO_1
  "0.4.0": "0x036078334509b514626504edc9fb252328d1a240e4e948bef8d0c08dff45927f",
  "0.3.1": "0x29927c8af6bccf3f6fda035981e765a7bdbf18a2dc0d630494f8758aa908e2b",
  "0.3.0": "0x1a736d6ed154502257f02b1ccdf4d9d1089f80811cd6acad48e6b6a9d1f2003"
}, te = {
  "0.1.1": "0x6e150953b26271a740bf2b6e9bca17cc52c68d765f761295de51ceb8526ee72",
  "0.1.0": "0x737ee2f87ce571a58c6c8da558ec18a07ceb64a6172d5ec46171fbc80077a48"
};
var Jn = typeof global == "object" && global && global.Object === Object && global, Xn = typeof self == "object" && self && self.Object === Object && self, de = Jn || Xn || Function("return this")(), ne = de.Symbol, Pt = Object.prototype, Zn = Pt.hasOwnProperty, Qn = Pt.toString, U = ne ? ne.toStringTag : void 0;
function ea(e) {
  var t = Zn.call(e, U), n = e[U];
  try {
    e[U] = void 0;
    var a = !0;
  } catch {
  }
  var s = Qn.call(e);
  return a && (t ? e[U] = n : delete e[U]), s;
}
var ta = Object.prototype, na = ta.toString;
function aa(e) {
  return na.call(e);
}
var ra = "[object Null]", sa = "[object Undefined]", rt = ne ? ne.toStringTag : void 0;
function oa(e) {
  return e == null ? e === void 0 ? sa : ra : rt && rt in Object(e) ? ea(e) : aa(e);
}
function Ft(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ia = "[object AsyncFunction]", ca = "[object Function]", la = "[object GeneratorFunction]", da = "[object Proxy]";
function ua(e) {
  if (!Ft(e))
    return !1;
  var t = oa(e);
  return t == ca || t == la || t == ia || t == da;
}
var we = de["__core-js_shared__"], st = function() {
  var e = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ha(e) {
  return !!st && st in e;
}
var fa = Function.prototype, ma = fa.toString;
function pa(e) {
  if (e != null) {
    try {
      return ma.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ga = /[\\^$.*+?()[\]{}|]/g, ba = /^\[object .+?Constructor\]$/, ya = Function.prototype, Sa = Object.prototype, wa = ya.toString, Ta = Sa.hasOwnProperty, _a = RegExp(
  "^" + wa.call(Ta).replace(ga, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Aa(e) {
  if (!Ft(e) || ha(e))
    return !1;
  var t = ua(e) ? _a : ba;
  return t.test(pa(e));
}
function va(e, t) {
  return e == null ? void 0 : e[t];
}
function je(e, t) {
  var n = va(e, t);
  return Aa(n) ? n : void 0;
}
var $ = je(Object, "create");
function Ia() {
  this.__data__ = $ ? $(null) : {}, this.size = 0;
}
function Ea(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ca = "__lodash_hash_undefined__", Na = Object.prototype, xa = Na.hasOwnProperty;
function ka(e) {
  var t = this.__data__;
  if ($) {
    var n = t[e];
    return n === Ca ? void 0 : n;
  }
  return xa.call(t, e) ? t[e] : void 0;
}
var Oa = Object.prototype, Pa = Oa.hasOwnProperty;
function Fa(e) {
  var t = this.__data__;
  return $ ? t[e] !== void 0 : Pa.call(t, e);
}
var Ba = "__lodash_hash_undefined__";
function Ra(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = $ && t === void 0 ? Ba : t, this;
}
function k(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
k.prototype.clear = Ia;
k.prototype.delete = Ea;
k.prototype.get = ka;
k.prototype.has = Fa;
k.prototype.set = Ra;
function Da() {
  this.__data__ = [], this.size = 0;
}
function ja(e, t) {
  return e === t || e !== e && t !== t;
}
function ue(e, t) {
  for (var n = e.length; n--; )
    if (ja(e[n][0], t))
      return n;
  return -1;
}
var Ua = Array.prototype, La = Ua.splice;
function Ha(e) {
  var t = this.__data__, n = ue(t, e);
  if (n < 0)
    return !1;
  var a = t.length - 1;
  return n == a ? t.pop() : La.call(t, n, 1), --this.size, !0;
}
function Va(e) {
  var t = this.__data__, n = ue(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function $a(e) {
  return ue(this.__data__, e) > -1;
}
function Ma(e, t) {
  var n = this.__data__, a = ue(n, e);
  return a < 0 ? (++this.size, n.push([e, t])) : n[a][1] = t, this;
}
function D(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
D.prototype.clear = Da;
D.prototype.delete = Ha;
D.prototype.get = Va;
D.prototype.has = $a;
D.prototype.set = Ma;
var Ga = je(de, "Map");
function za() {
  this.size = 0, this.__data__ = {
    hash: new k(),
    map: new (Ga || D)(),
    string: new k()
  };
}
function Wa(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function he(e, t) {
  var n = e.__data__;
  return Wa(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Ka(e) {
  var t = he(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function qa(e) {
  return he(this, e).get(e);
}
function Ya(e) {
  return he(this, e).has(e);
}
function Ja(e, t) {
  var n = he(this, e), a = n.size;
  return n.set(e, t), this.size += n.size == a ? 0 : 1, this;
}
function j(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
j.prototype.clear = za;
j.prototype.delete = Ka;
j.prototype.get = qa;
j.prototype.has = Ya;
j.prototype.set = Ja;
var Xa = "__lodash_hash_undefined__";
function Za(e) {
  return this.__data__.set(e, Xa), this;
}
function Qa(e) {
  return this.__data__.has(e);
}
function ae(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new j(); ++t < n; )
    this.add(e[t]);
}
ae.prototype.add = ae.prototype.push = Za;
ae.prototype.has = Qa;
function er(e, t, n, a) {
  for (var s = e.length, o = n + -1; ++o < s; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function tr(e) {
  return e !== e;
}
function nr(e, t, n) {
  for (var a = n - 1, s = e.length; ++a < s; )
    if (e[a] === t)
      return a;
  return -1;
}
function ar(e, t, n) {
  return t === t ? nr(e, t, n) : er(e, tr, n);
}
function rr(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && ar(e, t, 0) > -1;
}
function sr(e, t, n) {
  for (var a = -1, s = e == null ? 0 : e.length; ++a < s; )
    if (n(t, e[a]))
      return !0;
  return !1;
}
function or(e, t) {
  return e.has(t);
}
var Te = je(de, "Set");
function ir() {
}
function Bt(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(a) {
    n[++t] = a;
  }), n;
}
var cr = 1 / 0, lr = Te && 1 / Bt(new Te([, -0]))[1] == cr ? function(e) {
  return new Te(e);
} : ir, dr = 200;
function ur(e, t, n) {
  var a = -1, s = rr, o = e.length, i = !0, c = [], l = c;
  if (n)
    i = !1, s = sr;
  else if (o >= dr) {
    var d = lr(e);
    if (d)
      return Bt(d);
    i = !1, s = or, l = new ae();
  } else
    l = c;
  e:
    for (; ++a < o; ) {
      var u = e[a], h = u;
      if (u = n || u !== 0 ? u : 0, i && h === h) {
        for (var m = l.length; m--; )
          if (l[m] === h)
            continue e;
        c.push(u);
      } else s(l, h, n) || (l !== c && l.push(h), c.push(u));
    }
  return c;
}
function hr(e, t) {
  return t = typeof t == "function" ? t : void 0, e && e.length ? ur(e, void 0, t) : [];
}
function ot(e) {
  const t = Object.entries(I), n = Object.entries(te);
  switch (e) {
    case "cairo0":
      return t.filter(([a]) => v.lt(a, "0.3.0")).map(([, a]) => a);
    case "cairo1":
      return t.filter(([a]) => v.gte(a, "0.3.0")).map(([, a]) => a);
    case "multisig":
      return n.map(([, a]) => a);
    default:
      return t.map(([, a]) => a);
  }
}
function fr() {
  const e = v.maxSatisfying(Object.keys(I), "*");
  if (!e)
    throw new Error(`No argent account contract found: v${e} `);
  return I[e];
}
function Qo() {
  const e = v.maxSatisfying(Object.keys(te), "*");
  if (!e)
    throw new Error(`No argent multisig contract found: v${e} `);
  return te[e];
}
function mr() {
  return Object.entries(I).filter(([e]) => v.gte(e, "0.4.0")).map(([, e]) => e);
}
function ei() {
  const e = v.maxSatisfying(Object.keys(I), "<0.3.0");
  if (!e)
    throw new Error(`No argent account contract found: v${e} `);
  return I[e];
}
function pr() {
  const e = Object.entries(I).filter(([n]) => v.gte(n, "0.3.1")).map(([, n]) => n), t = Object.entries(te).filter(([n]) => v.gte(n, "0.1.1")).map(([, n]) => n);
  return [...e, ...t];
}
function ti() {
  return Object.entries(I).filter(([e]) => v.gte(e, "0.4.0")).map(([, e]) => e);
}
function ni() {
  const e = v.maxSatisfying(Object.keys(I), ">=0.4.0");
  if (!e)
    throw new Error(`No ledger account contract found: v${e}`);
  return I[e];
}
const gr = (e, t) => e.cairoVersion === t.cairoVersion && N(e.accountClassHash, t.accountClassHash);
function ai(e, t, n = []) {
  const a = Je.parse({
    cairoVersion: t.cairoVersion ?? "1",
    accountClassHash: t.classHash ?? fr()
  }), s = r.array(Je).parse(n), o = [
    ...ot("cairo0").map((d) => ({ cairoVersion: "0", accountClassHash: d })),
    ...ot("cairo1").map((d) => ({ cairoVersion: "1", accountClassHash: d }))
  ], l = hr([
    a,
    ...s,
    ...o
  ], gr).map((d) => ({
    implementation: d,
    address: Sr(d.cairoVersion, d.accountClassHash, e, t.guardian, t.salt)
  })).find((d) => N(d.address, t.address));
  if (!l)
    throw new gn({ code: "CALCULATED_ADDRESS_NO_MATCH" });
  return l.implementation;
}
function br(e, t, n, a, s, o = Yn[0]) {
  const i = yr(e, t, n, a);
  return {
    classHash: e === "0" ? o : t,
    constructorCalldata: O.compile(i),
    addressSalt: s || n
  };
}
function yr(e, t, n, a) {
  const s = e !== "0" && N(bn, t), o = {
    pubkey: n,
    ...s ? {} : { guardian: a || "0" }
  };
  if (mr().some((c) => N(c, t))) {
    const c = Xe(n, Ze.Starknet), l = a ? new et(tt.Some, Xe(a, Ze.Starknet)) : new et(tt.None, null);
    return { ownerSigner: c, guardianAsOption: l };
  }
  return e === "0" ? yn.parse({
    implementation: t,
    selector: Z.getSelectorFromName("initialize"),
    calldata: O.compile(o)
  }) : Sn.parse({
    owner: n,
    guardian: a
  });
}
function Sr(e, t, n, a, s) {
  const o = br(e, t, n, a, s);
  return Z.calculateContractAddressFromHash(o.addressSalt, o.classHash, o.constructorCalldata, 0);
}
const Rt = (e) => e.slice(0, 6) + "..." + e.slice(-4);
function it(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function wr(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function fe(e, ...t) {
  if (!wr(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function ct(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Tr(e, t) {
  fe(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const J = /* @__PURE__ */ BigInt(2 ** 32 - 1), lt = /* @__PURE__ */ BigInt(32);
function _r(e, t = !1) {
  return t ? { h: Number(e & J), l: Number(e >> lt & J) } : { h: Number(e >> lt & J) | 0, l: Number(e & J) | 0 };
}
function Ar(e, t = !1) {
  let n = new Uint32Array(e.length), a = new Uint32Array(e.length);
  for (let s = 0; s < e.length; s++) {
    const { h: o, l: i } = _r(e[s], t);
    [n[s], a[s]] = [o, i];
  }
  return [n, a];
}
const vr = (e, t, n) => e << n | t >>> 32 - n, Ir = (e, t, n) => t << n | e >>> 32 - n, Er = (e, t, n) => t << n - 32 | e >>> 64 - n, Cr = (e, t, n) => e << n - 32 | t >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Nr = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), dt = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, xr = (e) => e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
function ut(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = xr(e[t]);
}
const kr = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Or(e) {
  fe(e);
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += kr[e[n]];
  return t;
}
function Dt(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function jt(e) {
  return typeof e == "string" && (e = Dt(e)), fe(e), e;
}
class Pr {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Fr(e) {
  const t = (a) => e().update(jt(a)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
const Ut = [], Lt = [], Ht = [], Br = /* @__PURE__ */ BigInt(0), L = /* @__PURE__ */ BigInt(1), Rr = /* @__PURE__ */ BigInt(2), Dr = /* @__PURE__ */ BigInt(7), jr = /* @__PURE__ */ BigInt(256), Ur = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = L, n = 1, a = 0; e < 24; e++) {
  [n, a] = [a, (2 * n + 3 * a) % 5], Ut.push(2 * (5 * a + n)), Lt.push((e + 1) * (e + 2) / 2 % 64);
  let s = Br;
  for (let o = 0; o < 7; o++)
    t = (t << L ^ (t >> Dr) * Ur) % jr, t & Rr && (s ^= L << (L << /* @__PURE__ */ BigInt(o)) - L);
  Ht.push(s);
}
const [Lr, Hr] = /* @__PURE__ */ Ar(Ht, !0), ht = (e, t, n) => n > 32 ? Er(e, t, n) : vr(e, t, n), ft = (e, t, n) => n > 32 ? Cr(e, t, n) : Ir(e, t, n);
function Vr(e, t = 24) {
  const n = new Uint32Array(10);
  for (let a = 24 - t; a < 24; a++) {
    for (let i = 0; i < 10; i++)
      n[i] = e[i] ^ e[i + 10] ^ e[i + 20] ^ e[i + 30] ^ e[i + 40];
    for (let i = 0; i < 10; i += 2) {
      const c = (i + 8) % 10, l = (i + 2) % 10, d = n[l], u = n[l + 1], h = ht(d, u, 1) ^ n[c], m = ft(d, u, 1) ^ n[c + 1];
      for (let g = 0; g < 50; g += 10)
        e[i + g] ^= h, e[i + g + 1] ^= m;
    }
    let s = e[2], o = e[3];
    for (let i = 0; i < 24; i++) {
      const c = Lt[i], l = ht(s, o, c), d = ft(s, o, c), u = Ut[i];
      s = e[u], o = e[u + 1], e[u] = l, e[u + 1] = d;
    }
    for (let i = 0; i < 50; i += 10) {
      for (let c = 0; c < 10; c++)
        n[c] = e[i + c];
      for (let c = 0; c < 10; c++)
        e[i + c] ^= ~n[(c + 2) % 10] & n[(c + 4) % 10];
    }
    e[0] ^= Lr[a], e[1] ^= Hr[a];
  }
  n.fill(0);
}
class Ue extends Pr {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, a, s = !1, o = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = a, this.enableXOF = s, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, it(a), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Nr(this.state);
  }
  keccak() {
    dt || ut(this.state32), Vr(this.state32, this.rounds), dt || ut(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    ct(this);
    const { blockLen: n, state: a } = this;
    t = jt(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const i = Math.min(n - this.pos, s - o);
      for (let c = 0; c < i; c++)
        a[this.pos++] ^= t[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: a, blockLen: s } = this;
    t[a] ^= n, n & 128 && a === s - 1 && this.keccak(), t[s - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    ct(this, !1), fe(t), this.finish();
    const n = this.state, { blockLen: a } = this;
    for (let s = 0, o = t.length; s < o; ) {
      this.posOut >= a && this.keccak();
      const i = Math.min(a - this.posOut, o - s);
      t.set(n.subarray(this.posOut, this.posOut + i), s), this.posOut += i, s += i;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return it(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (Tr(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: a, outputLen: s, rounds: o, enableXOF: i } = this;
    return t || (t = new Ue(n, a, s, i, o)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = o, t.suffix = a, t.outputLen = s, t.enableXOF = i, t.destroyed = this.destroyed, t;
  }
}
const $r = (e, t, n) => Fr(() => new Ue(t, e, n)), Mr = /* @__PURE__ */ $r(1, 136, 256 / 8);
function Gr(e) {
  return `0x${Or(Mr(Dt(e)))}`;
}
const zr = (e) => {
  if (!Be(e))
    return;
  const t = /(\d+)$/, n = e.match(t);
  if (n)
    return n[1];
}, Wr = (e, t = !1) => {
  if (!Be(e))
    return "";
  const n = t ? e.replace(/[^0-9a-z ]/gi, "") : e, s = Re(n).split(" "), o = zr(n), i = s.map((c) => c[0]);
  return o && o.length > 1 && o.length < n.length ? [i[0], o.substring(0, 2)].join("") : s.length === 1 ? s[0].substring(0, 2) : [i[0], i[i.length - 1]].join("");
}, { toBigInt: Kr } = f, mt = (e) => {
  const t = e.replace("#", "");
  if (!/^[0-9A-F]{6}$/i.test(t))
    throw new Error(`Invalid color ${e}`);
  return `#${t}`;
}, re = (e, t) => {
  const n = mt(t.background), a = mt(t.color ?? "#ffffff"), s = Wr(e, !0), o = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="${n}" />
    <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" font-size="16" font-family="Barlow, Helvetica, Arial, sans-serif" fill="${a}">${s}</text>
  </svg>`;
  return `data:image/svg+xml;base64,${btoa(o)}`;
}, pt = [
  "02BBA8",
  "29C5FF",
  "0078A4",
  "FFBF3D",
  "FFA85C",
  "FF875B",
  "FF675C",
  "FF5C72"
], qr = (e) => {
  const t = Gr(e).slice(-2), n = parseInt(t, 16) % pt.length;
  return pt[n];
}, Yr = (e) => {
  try {
    return f.toHex(Kr(f.hexToDecimalString(e)));
  } catch {
  }
  return "";
}, ri = ({ accountName: e, networkId: t, accountAddress: n, backgroundColor: a }) => {
  const s = Yr(n), o = `${t}::${s}`, i = a || qr(o);
  return re(e, { background: i });
}, Jr = (e) => {
  const t = Ee.removeHexPrefix(Ee.sanitizeHex(f.toHex(e))), n = xt.decode(t);
  return kt.encode(n);
}, si = (e) => e.map(Jr), Xr = (e) => {
  const t = kt.decode(e);
  return Ee.sanitizeHex(xt.encode(t));
}, oi = (e) => e.map(Xr);
function ii(e, t) {
  const n = e.getTime(), a = t.getTime(), s = Math.abs(n - a);
  return Math.floor(s / (1e3 * 60 * 60 * 24));
}
const ci = (e) => (e || "false") === "true", li = async (e, t) => {
  try {
    return await e.getClassHashAt(t), !0;
  } catch {
    return !1;
  }
};
function di(e) {
  return !En(e);
}
const ui = (e) => {
  const t = /^(0|0x([a-f0-9A-F]+)?)$/;
  return !!(e === "" || t.test(e));
}, _ = (e) => !isNaN(parseFloat(e)) && isFinite(Number(e)), hi = (e, t = 16) => {
  const n = new RegExp(`^[0-9]*.?[0-9]{0,${t}}$`);
  return e === "" ? !0 : _(e) ? !!n.test(e) : !1;
}, Le = {
  CURRENCY: {
    minDecimalPlaces: 2,
    maxDecimalPlaces: 10,
    minDecimalSignificantDigits: 2,
    decimalPlacesWhenZero: 2,
    allowLeadingZerosInDecimalPart: !0
  },
  TOKEN: {
    minDecimalPlaces: 4,
    maxDecimalPlaces: 16,
    minDecimalSignificantDigits: 2,
    decimalPlacesWhenZero: 1,
    allowLeadingZerosInDecimalPart: !0
  }
}, Zr = (e, t) => Vt(e, {
  ...Le.CURRENCY,
  ...t || {}
}), Qr = (e, t) => Vt(e, {
  ...Le.TOKEN,
  ...t || {}
}), Vt = (e, { minDecimalPlaces: t, maxDecimalPlaces: n, minDecimalSignificantDigits: a, decimalPlacesWhenZero: s, allowLeadingZerosInDecimalPart: o } = Le.CURRENCY) => {
  if (!_(e))
    return null;
  const i = new Qe(typeof e == "bigint" ? e.toString() : e);
  let c;
  const l = `0.${"".padStart(s - 1, "0")}1`;
  if (i.lt(new Qe(l)) && !o)
    c = `0.${"".padStart(s, "0")}`;
  else if (i.gte(1))
    c = i.toFormat(t);
  else {
    const g = i.toFormat(n).split(".")[1].match(/^0+/), E = o && g && g.length ? g[0].length : 0, C = Math.max(E + a, t);
    c = i.toFormat(C);
  }
  let d = c.replace(/0+$/, "");
  const u = 1 + c.indexOf(".") + s;
  return d.length < u && (d = c.substring(0, u)), d;
}, G = 18;
function z({ value: e, decimals: t }) {
  if (t === 0)
    return e.toString();
  const n = e < 0n;
  e = n ? -e : e;
  const a = e.toString().padStart(t, "0"), s = a.slice(0, -t) || "0", o = a.slice(-t).replace(/0+$/, "");
  return `${n ? "-" : ""}${s}${o ? `.${o}` : ""}`;
}
const He = (e, t) => ({
  decimals: t,
  value: t >= e.decimals ? e.value * BigInt(10) ** BigInt(t - e.decimals) : e.value / BigInt(10) ** BigInt(e.decimals - t)
}), $t = (e) => {
  const t = e.value.toString().split("").reverse();
  let n = 0;
  for (let s = 0; s < t.length && t[s] === "0"; s++)
    n++;
  const a = e.decimals - n;
  return He(e, a);
}, Mt = (e, t) => {
  const n = Math.max(e.decimals, t.decimals), [a, s] = [e, t].map((o) => He(o, n));
  return [a.value, s.value, n];
}, me = (e) => (t, n) => {
  const [a, s, o] = Mt(t, n);
  return {
    decimals: o,
    value: e(a, s, o)
  };
}, W = (e) => (t, n) => {
  const [a, s] = Mt(t, n);
  return e(a, s);
}, es = me((e, t) => e + t), ts = me((e, t) => e - t), ns = me((e, t, n) => {
  if (t === BigInt(0))
    throw new Error("Division by zero is not allowed");
  return e * BigInt(10) ** BigInt(n) / t;
}), as = (e, t) => $t({
  decimals: e.decimals + t.decimals,
  value: e.value * t.value
}), rs = me((e, t) => {
  if (t === BigInt(0))
    throw new Error("Modulus by zero is not allowed");
  return e % t;
}), Ve = (e) => ({
  decimals: e.decimals,
  value: e.value >= BigInt(0) ? e.value : -e.value
}), Gt = W((e, t) => e === t), ss = W((e, t) => e < t), os = W((e, t) => e > t), is = W((e, t) => e <= t), cs = W((e, t) => e >= t), ls = (e, t) => !Gt(e, t);
function P(e, t) {
  let [n, a = ""] = e.split(".");
  const s = n.startsWith("-");
  return s && (n = n.slice(1)), a.length > t ? Number(a[t]) >= 5 ? a = (BigInt(a.slice(0, t)) + 1n).toString().padStart(t, "0") : a = a.slice(0, t) : a = a.padEnd(t, "0"), {
    value: BigInt(`${s ? "-" : ""}${n}${a}`),
    decimals: t
  };
}
function ds(e) {
  return z({ value: e, decimals: G });
}
function us(e) {
  return P(e, G);
}
function hs(e) {
  return z({ value: e, decimals: G });
}
function $e(e) {
  return P(e, G);
}
function fs(e) {
  return Ve({ value: e, decimals: 0 }).value;
}
function ms(e) {
  return Ve($e(e));
}
function ps(e, t) {
  return {
    value: BigInt(e),
    decimals: t
  };
}
const gs = { value: 1n, decimals: 0 };
function bs(e) {
  return r.string().refine((t) => /^-?\d+(\.\d+)?$/.test(t), { message: "Invalid number format" }).transform((t) => P(t, e));
}
const fi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ONE: gs,
  abs: Ve,
  absBigInt: fs,
  add: es,
  createUnitsSchema: bs,
  div: ns,
  eq: Gt,
  formatCurrency: hs,
  formatEther: ds,
  formatUnits: z,
  gt: os,
  gte: cs,
  lt: ss,
  lte: is,
  mod: rs,
  mul: as,
  not: ls,
  parseCurrency: $e,
  parseCurrencyAbs: ms,
  parseEther: us,
  parseUnits: P,
  sub: ts,
  toBigDecimal: ps,
  toFixedDecimals: He,
  toTiniestPossibleDecimal: $t
}, Symbol.toStringTag, { value: "Module" })), ys = (e, t = 18) => {
  const n = e.replace(",", ".");
  return !e || !_(n) ? 0n : P(n, Number(t)).value;
};
function M(e) {
  return x.bnToUint256(e);
}
const mi = (e, t) => `${e} ${t}${e === 1 ? "" : "s"}`, pi = (e) => new Promise((t, n) => {
  const a = new FileReader();
  a.onload = () => {
    var s;
    return a.result ? t((s = a.result) == null ? void 0 : s.toString()) : n(new Error("Could not read file"));
  }, a.onerror = n, a.onabort = n.bind(null, new Error("User aborted")), a.readAsText(e);
});
function gi(e) {
  try {
    return Cn(Ct(e));
  } catch {
    return e;
  }
}
const bi = (e, t) => {
  const n = new URLSearchParams(t), a = n.size ? `?${n}` : "";
  return p(...ie(e), a);
};
function yi(e) {
  return (...t) => {
    e(...t);
  };
}
class Ss extends Error {
  constructor(t, n) {
    super(`${t}::${n}`), this.name = t, this.code = n, this.name = t;
  }
}
class gt extends Ss {
  constructor(t) {
    super("BackendPaginationError", t);
  }
}
const bt = 32;
class Si {
  constructor(t, n, a) {
    this.apiBase = t, this.headers = n, this.imageOptimizationUrl = a, this.httpService = new De(this.headers, "json");
  }
  async getNfts(t, n, a, s = 1) {
    const o = this.normalizeAddress(a), i = p(this.apiBase, "pandora", t, n), c = this.pageToPageIndex(s), d = `${p(i, "profile", o, "nfts")}?page=${c}&size=${bt}`, u = await this.httpService.get(d), h = u.content.map((m) => this.mapItem(m, a));
    return {
      totalPages: u.totalPages,
      page: u.number + 1,
      count: h.length,
      nfts: h
    };
  }
  async getCollection(t, n, a) {
    const s = this.normalizeAddress(a), o = p(this.apiBase, "pandora", t, n), i = p(o, "collection", s), c = `${o}/collection/${s}`, [l, d] = await Promise.all([
      this.httpService.get(i),
      this.httpService.get(c)
    ]), u = _e(l), h = d.content.map((m) => this.mapItem(m));
    return {
      ...u,
      nfts: {
        totalPages: d.totalPages,
        page: d.number,
        count: h.length,
        data: h
      }
    };
  }
  async getNft(t, n, a, s) {
    const o = this.normalizeAddress(a), i = p(this.apiBase, "pandora", t, n), c = p(i, "nft", o, s), l = await this.httpService.get(c);
    return this.mapItem(l);
  }
  async getProfileCollections(t, n, a, s = 1, o = !1) {
    const i = this.pageToPageIndex(s), c = this.normalizeAddress(a), l = p(this.apiBase, "pandora", t, n), d = p(l, "profile", c, "collections", `?page=${i}&size=${bt}`), u = await this.httpService.get(d), h = [];
    for (const m of u.content)
      if (o) {
        const g = await this.getCollectionMetrics(t, n, m.contractAddress);
        h.push(_e(m, g));
      } else
        h.push(_e(m));
    return {
      totalPages: u.totalPages,
      page: u.number + 1,
      count: h.length,
      collections: h
    };
  }
  async getCollectionMetrics(t, n, a) {
    const s = this.normalizeAddress(a), o = p(this.apiBase, "pandora", t, n), i = p(o, "collection", s, "metrics");
    return this.httpService.get(i);
  }
  normalizeAddress(t) {
    return ce.parse(t);
  }
  pageToPageIndex(t) {
    if (!Number.isInteger(t))
      throw new gt("notANumber");
    const n = t - 1;
    if (n < 0)
      throw new gt("tooLow");
    return n;
  }
  optimizeImage(t, n, a) {
    if (!t)
      return;
    const s = new URLSearchParams({
      url: t,
      w: (n ?? 400).toString(),
      h: (a ?? 400).toString()
    });
    return `${this.imageOptimizationUrl}?${s.toString()}`;
  }
  mapItem(t, n) {
    var s;
    const a = t.name ?? t.tokenId;
    return {
      token_id: t.tokenId,
      contract_address: t.contractAddress,
      name: a,
      spec: "spec" in t ? ws(t.spec) : void 0,
      description: "",
      best_bid_order: {
        payment_amount: "bestListPrice" in t ? BigInt(t.bestListPrice) : void 0
      },
      properties: "properties" in t && t.properties.map((o) => ({ key: o.key, value: o.value })) || [],
      image_uri: this.optimizeImage(t.imageUrls.preview) ?? re(a, {
        background: "#15192A",
        color: "#ffffff"
      }),
      image_url_copy: this.optimizeImage(t.imageUrls.full) ?? re(a, {
        background: "#15192A",
        color: "#ffffff"
      }),
      owner: {
        account_address: ((s = t.owner) == null ? void 0 : s.address) || n
      },
      contract_name: Rt(t.contractAddress)
    };
  }
}
function ws(e) {
  switch (e) {
    case "erc721":
    case "starknetErc721":
      return "ERC721";
    case "erc1155":
    case "starknetErc1155":
      return "ERC1155";
  }
}
function _e(e, t) {
  return {
    contractAddress: y.parse(e.contractAddress),
    name: e.name || Rt(e.contractAddress),
    description: e.description ?? "",
    imageUri: e.imageUrls.preview ?? re(e.name || e.contractAddress.replace("0x", ""), {
      background: "#15192A",
      color: "#ffffff"
    }),
    ...t && {
      owners: {
        total: t.numberOfItems,
        unique: t.uniqueOwners
      },
      ...t.floorPrice && {
        //floorPrice: getEthTokenPrice(BigInt(metrics.floorPrice)),
        floorPrice: BigInt(t.floorPrice)
      }
    }
  };
}
const zt = async (e, t, n, a, s = 1) => {
  const o = await e.getNfts(t, n, a, s);
  if (s < o.totalPages) {
    const i = await zt(e, t, n, a, o.page + 1);
    return {
      ...o,
      nfts: o.nfts.concat(i.nfts)
    };
  }
  return o;
}, wi = (e, t, n, a, s) => {
  const { data: o, ...i } = le(a && [a, "nfts"], () => a && zt(e, t, n, a), {
    refreshInterval: 3e5,
    ...s
  });
  return { nfts: o == null ? void 0 : o.nfts, ...i };
}, Ti = (e, t, n, a, s) => {
  const { data: o, ...i } = le(a && [`${a}`, "nfts-collection"], () => a && e.getCollection(t, n, a), {
    refreshInterval: 6e4,
    ...s
  });
  return { collection: o, ...i };
}, _i = (e, t, n, a, s, o) => {
  const { data: i, ...c } = le(s && a && [`${a}:${s}`, "nft"], () => s && a ? e.getNft(t, n, a, s) : void 0, {
    refreshInterval: 6e4,
    revalidateOnFocus: !1,
    revalidateOnMount: !1,
    ...o
  });
  return { nft: i, ...c };
}, Ai = ({ image_uri: e, image_url_copy: t }) => {
  if (e && t) {
    if (!t.startsWith("ipfs://"))
      return t;
    if (!e.startsWith("ipfs://"))
      return e;
  }
  return t || e;
}, vi = (e, t) => e.token_id === t.token_id && N(e.contract_address, t.contract_address);
class Ii {
  constructor(t, n) {
    this.cachePromise = n.open(t).catch((a) => (console.error(new Error("Failed to open cache", { cause: a })), null));
  }
  async get(t) {
    const n = await this.cachePromise;
    if (!n)
      throw new Error("No cache available");
    const a = await n.match(t).catch(() => {
      throw new Error("Failed to match cache");
    });
    if (!a)
      throw new Error("Failed to match cache");
    return a.clone();
  }
  async set(t, n) {
    const a = await this.cachePromise;
    a && await a.put(t, n).catch(() => {
      throw new Error("Failed to match cache");
    });
  }
  async delete(t) {
    const n = await this.cachePromise;
    return n ? n.delete(t) : !1;
  }
  // should be called on logout
  async flush() {
    const t = await this.cachePromise;
    if (!t)
      return;
    const n = await t.keys();
    await Promise.allSettled(n.map((a) => t.delete(a)));
  }
}
const Me = [
  {
    address: "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/eth.png"
  },
  {
    address: "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/eth.png"
  },
  {
    address: "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    networkId: "localhost",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/eth.png"
  },
  {
    address: "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    name: "Starknet",
    symbol: "STRK",
    decimals: "18",
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/strk.png"
  },
  {
    address: "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    name: "Starknet",
    symbol: "STRK",
    decimals: "18",
    networkId: "integration",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/strk.png"
  },
  {
    address: "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    name: "Starknet",
    symbol: "STRK",
    decimals: "18",
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/strk.png"
  },
  {
    address: "0x00da114221cb83fa859dbdb4c44beeaa0bb37c7537ad5ae66fe5e0efd20e6eb3",
    name: "DAI",
    symbol: "DAI",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/dai.png"
  },
  {
    address: "0x03e85bfbb8e2a42b7bead9e88e9a1b19dbccf661471061807292120462396ec9",
    name: "DAI",
    symbol: "DAI",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/dai.png"
  },
  {
    address: "0x06f2a0dfeff180133de890ad69c6ba294574c5f34a67890fd22464f348c4d03c",
    name: "DAI",
    symbol: "DAI",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/dai.png"
  },
  {
    address: "0x03fe2b97c1fd336e750087d68b9b867997fd64a2661ff3ca5a7c771641e8e7ac",
    name: "Wrapped BTC",
    symbol: "WBTC",
    decimals: 8,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/wbtc.png"
  },
  {
    address: "0x12d537dc323c439dc65c976fad242d5610d27cfb5f31689a0a319b8be7f3d56",
    name: "Wrapped BTC",
    symbol: "WBTC",
    decimals: 8,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/wbtc.png"
  },
  {
    address: "0x020d208b9e57a7f92bfa9f61135446e0961afc340378be97dbd317453c0950ae",
    name: "Wrapped BTC",
    symbol: "WBTC",
    decimals: 8,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/wbtc.png"
  },
  {
    address: "0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8",
    name: "USD Coin",
    symbol: "USDC",
    decimals: 6,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdc.png"
  },
  {
    address: "0x005a643907b9a4bc6a55e9069c4fd5fd1f5c79a22470690f75556c4736e34426",
    name: "USD Coin",
    symbol: "USDC",
    decimals: 6,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdc.png"
  },
  {
    address: "0x07ab0b8855a61f480b4423c46c32fa7c553f0aac3531bbddaa282d86244f7a23",
    name: "USD Coin",
    symbol: "USDC",
    decimals: 6,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdc.png"
  },
  {
    address: "0x068f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8",
    name: "Tether USD",
    symbol: "USDT",
    decimals: 6,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdt.png"
  },
  {
    address: "0x386e8d061177f19b3b485c20e31137e6f6bc497cc635ccdfcab96fadf5add6a",
    name: "Tether USD",
    symbol: "USDT",
    decimals: 6,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdt.png"
  },
  {
    address: "0x00585c32b625999e6e5e78645ff8df7a9001cf5cf3eb6b80ccdd16cb64bd3a34",
    name: "zkLend Token",
    symbol: "ZEND",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/zend.png"
  },
  {
    address: "0x06ea04cd7e40bfef07c3625e2b3472839093d966bf601568128436466f962fcf",
    name: "Baby Laika",
    symbol: "BABYLAIKA",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/babylaika.png"
  },
  {
    address: "0x004a8ff6a7b121c55d5e21af478265c5798f574abaa41efadf569d6939705896",
    name: "Baby Laika",
    symbol: "BABYLAIKA",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/babylaika.png"
  },
  {
    address: "0x0782f0ddca11d9950bc3220e35ac82cf868778edb67a5e58b39838544bc4cd0f",
    name: "Starknet Voting Token",
    symbol: "vSTRK",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/vstrk.png"
  },
  {
    address: "0x075afe6402ad5a5c20dd25e10ec3b3986acaa647b77e4ae24b0cbc9a54a27a87",
    name: "Ekubo Protocol",
    symbol: "EKUBO",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/ekubo.png"
  }
], Ts = async (e, t, n) => {
  const a = await n.callContract({
    contractAddress: e,
    entrypoint: "balanceOf",
    calldata: [t]
  });
  return BigInt(f.toHex(x.uint256ToBN({
    low: a[0],
    high: a[1]
  })));
}, Ei = async (e, t, n) => {
  const a = Me.filter((o) => o.networkId === e);
  return (await Promise.allSettled(a.map((o) => t.callContract({
    contractAddress: o.address,
    entrypoint: "balanceOf",
    calldata: [n]
  })))).reduce((o, i, c) => {
    if (i.status === "fulfilled" && Nn(i.value) || i.status === "rejected" || i.value[0] === "0x0" && i.value[1] === "0x0")
      return o;
    const l = BigInt(f.toHex(x.uint256ToBN({
      low: i.value[0],
      high: i.value[1]
    }))), d = {
      ...a[c],
      balance: l
    };
    return o.push(d), o;
  }, []);
}, Ci = async () => Me, Ni = ({ address: e, networkId: t }) => Me.find((a) => a.address === e && a.networkId === t), xi = ({ amount: e, decimals: t, unitCurrencyValue: n }) => {
  if (!_(e) || !_(t) || !_(n))
    return;
  const a = Number(t), s = BigInt(e) * $e(n.toString()).value;
  return z({
    value: s,
    decimals: a + G
  });
}, ki = ({ unitAmount: e, decimals: t }) => {
  if (e === void 0 || !_(e) || t === void 0 || !_(t))
    return;
  const n = Number(t);
  return P(e.toString(), n).value.toString();
}, Oi = (e) => _(e) ? Number(e) : 18, { UINT_256_MAX: _s } = x, As = (e) => String(e) === String(_s), Pi = (e, t = "$", n) => {
  if (e === void 0 || !_(e))
    return null;
  const a = Zr(e, n);
  return [t, a].filter(Boolean).join("");
}, vs = "Unlimited", Fi = ({ amount: e, decimals: t, symbol: n, showPlusSign: a = !1, withSymbol: s = !0, unlimitedText: o = vs, prettyConfigOverrides: i }) => {
  if (!_(e))
    return null;
  let c, l = !1;
  if (As(e))
    c = o;
  else {
    const u = Number(t), h = BigInt(e);
    l = h > 0n;
    const m = u > 0 ? z({ value: h, decimals: u }) : h.toString();
    c = u > 0 ? Qr(m, i) : m;
  }
  const d = [c, s && n].filter(Boolean).join(" ");
  return a && l ? `+${d}` : d;
};
var Wt = {};
function w(e, t) {
  typeof t == "boolean" && (t = { forever: t }), this._originalTimeouts = JSON.parse(JSON.stringify(e)), this._timeouts = e, this._options = t || {}, this._maxRetryTime = t && t.maxRetryTime || 1 / 0, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._timer = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
}
var Is = w;
w.prototype.reset = function() {
  this._attempts = 1, this._timeouts = this._originalTimeouts.slice(0);
};
w.prototype.stop = function() {
  this._timeout && clearTimeout(this._timeout), this._timer && clearTimeout(this._timer), this._timeouts = [], this._cachedTimeouts = null;
};
w.prototype.retry = function(e) {
  if (this._timeout && clearTimeout(this._timeout), !e)
    return !1;
  var t = (/* @__PURE__ */ new Date()).getTime();
  if (e && t - this._operationStart >= this._maxRetryTime)
    return this._errors.push(e), this._errors.unshift(new Error("RetryOperation timeout occurred")), !1;
  this._errors.push(e);
  var n = this._timeouts.shift();
  if (n === void 0)
    if (this._cachedTimeouts)
      this._errors.splice(0, this._errors.length - 1), n = this._cachedTimeouts.slice(-1);
    else
      return !1;
  var a = this;
  return this._timer = setTimeout(function() {
    a._attempts++, a._operationTimeoutCb && (a._timeout = setTimeout(function() {
      a._operationTimeoutCb(a._attempts);
    }, a._operationTimeout), a._options.unref && a._timeout.unref()), a._fn(a._attempts);
  }, n), this._options.unref && this._timer.unref(), !0;
};
w.prototype.attempt = function(e, t) {
  this._fn = e, t && (t.timeout && (this._operationTimeout = t.timeout), t.cb && (this._operationTimeoutCb = t.cb));
  var n = this;
  this._operationTimeoutCb && (this._timeout = setTimeout(function() {
    n._operationTimeoutCb();
  }, n._operationTimeout)), this._operationStart = (/* @__PURE__ */ new Date()).getTime(), this._fn(this._attempts);
};
w.prototype.try = function(e) {
  this.attempt(e);
};
w.prototype.start = function(e) {
  this.attempt(e);
};
w.prototype.start = w.prototype.try;
w.prototype.errors = function() {
  return this._errors;
};
w.prototype.attempts = function() {
  return this._attempts;
};
w.prototype.mainError = function() {
  if (this._errors.length === 0)
    return null;
  for (var e = {}, t = null, n = 0, a = 0; a < this._errors.length; a++) {
    var s = this._errors[a], o = s.message, i = (e[o] || 0) + 1;
    e[o] = i, i >= n && (t = s, n = i);
  }
  return t;
};
(function(e) {
  var t = Is;
  e.operation = function(n) {
    var a = e.timeouts(n);
    return new t(a, {
      forever: n && (n.forever || n.retries === 1 / 0),
      unref: n && n.unref,
      maxRetryTime: n && n.maxRetryTime
    });
  }, e.timeouts = function(n) {
    if (n instanceof Array)
      return [].concat(n);
    var a = {
      retries: 10,
      factor: 2,
      minTimeout: 1 * 1e3,
      maxTimeout: 1 / 0,
      randomize: !1
    };
    for (var s in n)
      a[s] = n[s];
    if (a.minTimeout > a.maxTimeout)
      throw new Error("minTimeout is greater than maxTimeout");
    for (var o = [], i = 0; i < a.retries; i++)
      o.push(this.createTimeout(i, a));
    return n && n.forever && !o.length && o.push(this.createTimeout(i, a)), o.sort(function(c, l) {
      return c - l;
    }), o;
  }, e.createTimeout = function(n, a) {
    var s = a.randomize ? Math.random() + 1 : 1, o = Math.round(s * Math.max(a.minTimeout, 1) * Math.pow(a.factor, n));
    return o = Math.min(o, a.maxTimeout), o;
  }, e.wrap = function(n, a, s) {
    if (a instanceof Array && (s = a, a = null), !s) {
      s = [];
      for (var o in n)
        typeof n[o] == "function" && s.push(o);
    }
    for (var i = 0; i < s.length; i++) {
      var c = s[i], l = n[c];
      n[c] = (function(u) {
        var h = e.operation(a), m = Array.prototype.slice.call(arguments, 1), g = m.pop();
        m.push(function(E) {
          h.retry(E) || (E && (arguments[0] = h.mainError()), g.apply(this, arguments));
        }), h.attempt(function() {
          u.apply(n, m);
        });
      }).bind(n, l), n[c].options = a;
    }
  };
})(Wt);
var Es = Wt, Cs = Es;
function Ns(e, t) {
  function n(a, s) {
    var o = t || {}, i;
    "randomize" in o || (o.randomize = !0), i = Cs.operation(o);
    function c(u) {
      s(u || new Error("Aborted"));
    }
    function l(u, h) {
      if (u.bail) {
        c(u);
        return;
      }
      i.retry(u) ? o.onRetry && o.onRetry(u, h) : s(i.mainError());
    }
    function d(u) {
      var h;
      try {
        h = e(c, u);
      } catch (m) {
        l(m, u);
        return;
      }
      Promise.resolve(h).then(a).catch(function(g) {
        l(g, u);
      });
    }
    i.attempt(d);
  }
  return new Promise(n);
}
var xs = Ns;
const ks = /* @__PURE__ */ wn(xs);
var Ne;
(function(e) {
  e.NO_TOKEN_API_URL = "NO_TOKEN_API_URL is not defined", e.NO_TOKEN_PRICE_API_URL = "NO_TOKEN_PRICE_API_URL is not defined", e.TOKENS_DEFI_DECOMPOSITION_URL = "TOKENS_DEFI_DECOMPOSITION_URL is not defined", e.TOKENS_AIRDROPS_API_URL = "TOKENS_AIRDROPS_API_URL is not defined", e.TOKEN_PARSING_ERROR = "Unable to parse token data response", e.TOKEN_PRICE_PARSING_ERROR = "Unable to parse token price response", e.TOKEN_DEFI_DECOMPOSITION_PARSING_ERROR = "Unable to parse token defi decomposition response", e.TOKEN_PRICE_NOT_FOUND = "Token price not found", e.TOKEN_NOT_FOUND = "Token not found", e.TOKEN_DETAILS_NOT_FOUND = "Token details not found", e.FEE_TOKEN_NOT_FOUND = "Fee token not found", e.UNABLE_TO_CALCULATE_CURRENCY_VALUE = "Unable to calculate currency value", e.UNSAFE_DECIMALS = "Unsafe decimals in token";
})(Ne || (Ne = {}));
class Os extends Pe {
  constructor(t) {
    super(t, Ne), this.name = "TokenError";
  }
}
const Kt = r.union([
  r.literal("concentratedLiquidityPosition"),
  r.literal("collateralizedDebtPosition")
]), Ps = r.object({
  status: r.literal("initialising")
}).or(r.object({
  status: r.literal("initialised"),
  balances: r.array(r.object({
    tokenAddress: ce,
    tokenBalance: r.string()
  }))
})), K = r.object({
  id: r.number(),
  address: y,
  brandColor: r.string().optional(),
  name: r.string(),
  symbol: r.string(),
  decimals: r.number(),
  iconUrl: r.string().optional(),
  sendable: r.boolean(),
  popular: r.boolean(),
  refundable: r.boolean(),
  listed: r.boolean(),
  tradable: r.boolean(),
  category: r.union([
    r.literal("tokens"),
    r.literal("currencies"),
    r.literal("savings")
  ]),
  pricingId: r.number().optional(),
  dappId: r.string().optional(),
  marketData: r.object({
    marketCap: r.number(),
    marketCap24hChange: r.number(),
    dailyVolume: r.number(),
    rank: r.number()
  }).optional(),
  tags: r.array(r.string()).optional()
}), Fs = r.object({
  tokens: r.array(K)
}), Bs = K, qt = r.object({
  pricingId: r.number(),
  ethValue: r.string(),
  ccyValue: r.string(),
  ethDayChange: r.string(),
  ccyDayChange: r.string()
}), Bi = r.object({
  prices: r.array(qt)
}), yt = r.object({
  tokenAddress: ce,
  principal: r.string(),
  accruedFees: r.string(),
  minPrice: r.string(),
  maxPrice: r.string(),
  currentPrice: r.string()
}), Yt = r.object({
  tokenAddress: y.optional(),
  totalBalances: r.record(r.string())
}), Jt = Yt.extend({
  tokenId: r.string(),
  data: r.object({
    poolFeePercentage: r.string(),
    tickSpacingPercentage: r.string().optional(),
    token0: yt,
    token1: yt
  })
}), Ri = r.array(Jt), Xt = Yt.extend({
  data: r.object({
    apy: r.string().optional(),
    group: r.number().optional(),
    collateral: r.boolean(),
    debt: r.boolean(),
    lending: r.boolean()
  })
}), Di = r.array(Xt), Rs = r.array(Jt.or(Xt)), Ds = r.object({
  name: r.string(),
  manageUrl: r.string(),
  type: Kt,
  groups: r.record(r.object({
    name: r.string().optional(),
    healthRatio: r.string().optional()
  })).optional(),
  positions: Rs
}), js = r.object({
  dappId: r.string(),
  products: r.array(Ds)
}), Us = r.object({
  dapps: r.array(js)
}), Ls = r.object({
  name: r.string().optional(),
  tokenAddress: y,
  amount: r.string().optional(),
  claimUrl: r.string().optional(),
  claimStart: r.number(),
  claimEnd: r.number().optional()
}), ji = r.object({
  accountAddress: y,
  chain: r.string(),
  airdrops: r.array(Ls)
});
class Ui {
  constructor(t, n) {
    this.apiBase = t, this.httpService = n, this.TOKENS_INFO_URL = "/tokens/info", this.TOKENS_DEFI_DECOMPOSITION_URL = "/tokens/defi/decomposition";
  }
  /**
   * Fetch tokens info from backend
   * @param {Address} tokenAddress - The token address.
   * @returns {Promise<ApiTokenInfo[]>} - The fetched tokens or undefined if there was an error or not default network
   */
  async fetchTokensInfoFromBackend(t) {
    const n = p(this.apiBase, this.TOKENS_INFO_URL, t ?? "", "?chain=starknet"), a = await this.httpService.get(n), s = Fs.safeParse(a);
    if (s.success)
      return s.data.tokens;
    const o = Bs.safeParse(a);
    if (o.success)
      return [o.data];
  }
  /**
   * Fetch list of tokens and balances for given account from backend
   * @param {Address} address - The account address.
   * @returns {Promise<BaseTokenWithBalance[]>} - The fetched balances for the account address.
   */
  async fetchAddressTokenBalancesFromBackend(t, n, a) {
    const s = p(this.apiBase, "activity", "starknet", n, "account", t, "balance");
    return (await ks(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async (c) => {
        let l;
        try {
          l = await this.httpService.get(s);
        } catch {
          return c(new Error("Error fetching")), [];
        }
        const d = Ps.safeParse(l);
        if (!d.success)
          return c(new Error("Error parsing response")), [];
        if (d.data.status !== "initialised")
          throw new Error("Not initialised yet");
        return d.data.balances;
      },
      {
        /** seems to take 5-10 sec for initialised state */
        retries: 5,
        minTimeout: 5e3,
        ...a
      }
    )).map((c) => ({
      address: c.tokenAddress,
      balance: c.tokenBalance,
      networkId: n
    }));
  }
  async fetchDefiDecomposition(t) {
    const n = p(this.apiBase, this.TOKENS_DEFI_DECOMPOSITION_URL, t, "?chain=starknet"), a = await this.httpService.get(n);
    if (!Us.safeParse(a).success)
      throw new Os({ code: "TOKEN_DEFI_DECOMPOSITION_PARSING_ERROR" });
    return a.dapps;
  }
}
const pe = r.object({
  address: y,
  networkId: r.string({ required_error: "Network is required" })
}, { required_error: "BaseToken is required" });
pe.required().extend({
  balance: r.string()
});
const Zt = pe.required().extend({
  id: r.number().optional(),
  name: r.string().optional(),
  symbol: r.string().optional(),
  decimals: r.coerce.number().optional(),
  iconUrl: r.string().url("").optional().or(r.literal("")),
  // fallback since some iconUrls are empty, causing validation to fail
  pricingId: r.number().optional(),
  category: r.string().optional(),
  dappId: r.string().optional(),
  brandColor: r.string().optional()
}), Hs = Zt.extend({
  balance: r.string()
}), Vs = Zt.extend({
  currencyValue: r.string(),
  ccyDayChange: r.string().optional(),
  ethDayChange: r.string().optional(),
  unitCurrencyValue: r.string().optional()
}), Ge = Vs.extend({
  ...Hs.shape
});
r.array(Ge);
pe.extend({
  ...qt.shape
});
pe.extend({
  ...K.shape
});
const St = Ge.extend({
  accruedFees: r.string(),
  currentPrice: r.string(),
  maxPrice: r.string(),
  minPrice: r.string(),
  principal: r.string()
}), Qt = r.object({
  address: y.optional(),
  currencyValue: r.string().default("0")
}), en = Qt.extend({
  poolFeePercentage: r.string(),
  tickSpacingPercentage: r.string().optional(),
  tokenId: r.string().optional(),
  unitCurrencyValueToken0: r.string().optional(),
  unitCurrencyValueToken1: r.string().optional(),
  token0: St,
  token1: St
}), Li = r.array(en), Hi = r.object({
  name: r.string().optional(),
  healthRatio: r.string().optional(),
  accountAddress: y.optional()
}), tn = Qt.extend({
  totalBalances: r.record(r.string()),
  collateral: r.boolean(),
  debt: r.boolean(),
  lending: r.boolean(),
  apy: r.string().optional(),
  group: r.string().optional(),
  unitCurrencyValue: r.string().optional(),
  positionToken: K.or(r.undefined()),
  token: Ge.optional(),
  accountAddress: y.optional(),
  accountAddressGroup: r.string().optional()
}), Vi = r.array(tn), $s = en.or(tn), Ms = r.record(r.object({
  name: r.string().optional(),
  healthRatio: r.string().optional(),
  accountAddress: y.optional()
})), Gs = r.object({
  type: Kt,
  manageUrl: r.string().url().optional(),
  name: r.string(),
  positions: r.array($s),
  // other types will be added when available from be
  positionsTotalValue: r.string(),
  brandColor: r.string().optional(),
  groups: Ms.optional(),
  accountAddress: y
}), zs = r.array(Gs), $i = r.object({
  dappId: r.string(),
  products: zs
}), Ws = r.object({
  name: r.string().optional(),
  tokenAddress: y,
  token: K.optional(),
  amount: r.string().optional(),
  claimUrl: r.string().optional(),
  claimStart: r.number(),
  claimEnd: r.number().optional()
}), Mi = r.array(Ws), Ks = (e, t = 18) => P(e.replace(",", "."), Number(t)), qs = r.string().trim().refine((e) => e !== "", {
  message: "Amount is required"
}).refine((e) => {
  try {
    const t = Ks(e).value;
    if (t < 0n)
      throw new Error("Amount must be positive");
    if (t === 0n)
      throw new Error("Amount can not be zero");
    if (t > x.UINT_256_MAX)
      throw new Error("Amount is too big");
  } catch {
    throw new Error("Amount should be a number");
  }
  return !0;
}, { message: "Invalid amount" }), Gi = (e) => !!qs.parse(e), zi = (e, t, n, a) => ({
  contractAddress: e,
  entrypoint: "transfer",
  calldata: O.compile({
    recipient: t,
    amount: M(ys(n, a))
  })
}), Wi = (e, t, n, a) => ({
  contractAddress: e,
  entrypoint: "transferFrom",
  calldata: O.compile({
    from_: t,
    to: n,
    tokenId: M(a)
    // OZ specs need a uint256 as tokenId
  })
}), Ki = (e, t, n, a) => ({
  contractAddress: e,
  entrypoint: "safeTransferFrom",
  calldata: O.compile({
    from_: t,
    to: n,
    tokenId: M(a),
    amount: M(1),
    data_len: "0"
  })
}), Ys = r.object({
  data: r.object({
    code: r.string().optional(),
    // "STARKNAME_NOT_FOUND",
    name: r.string().optional(),
    // "AddressError"
    message: r.string()
    // "foo.stark not found"
  })
}), qi = (e) => {
  const t = Ys.safeParse(e);
  if (t.success)
    return t.data.data.message;
}, Js = 3, nn = process.env.FEE_OVERHEAD ? parseFloat(process.env.FEE_OVERHEAD) : Js, Xs = 1.5, se = 10, an = ({ estimatedFee: e, overheadMultiplier: t = nn }) => {
  const a = f.toBigInt(e) * BigInt(t * se) / BigInt(se);
  return f.toHex(a);
}, Yi = ({ suggestedMaxFee: e, overheadMultiplier: t = nn, starknetJsOverheadMultiplier: n = Xs }) => {
  const s = f.toBigInt(e) * BigInt(se) / BigInt(n * se);
  return an({ estimatedFee: s, overheadMultiplier: t });
};
var xe;
(function(e) {
  e.SIMULATE_AND_REVIEW_FAILED = "Missing simulation";
})(xe || (xe = {}));
class Zs extends Pe {
  constructor(t) {
    super(t, xe), this.name = "EstimateError";
  }
}
const Ji = r.object({
  type: r.enum(["DECLARE", "DEPLOY", "DEPLOY_ACCOUNT", "INVOKE"]).default("INVOKE"),
  calls: r.array(Ie).or(Ie).optional(),
  calldata: r.array(r.string()).optional(),
  classHash: X.optional(),
  salt: X.optional(),
  signature: r.array(r.string()).optional()
});
function rn(e) {
  return Re(e.unit) === "WEI";
}
function Qs(e) {
  return Re(e.unit) === "FRI";
}
function B(e, t) {
  return rn(e) ? {
    ...e,
    maxFee: t(e.maxFee),
    overallFee: t(e.overallFee),
    gasPrice: t(e.gasPrice),
    gasUsage: t(e.gasUsage)
  } : {
    ...e,
    overallFee: t(e.overallFee),
    gasPrice: t(e.gasPrice),
    gasUsage: t(e.gasUsage),
    maxAmount: t(e.maxAmount),
    maxPricePerUnit: t(e.maxPricePerUnit)
  };
}
function V(e) {
  return rn(e) ? {
    maxFee: e.maxFee
  } : {
    amount: e.maxAmount,
    pricePerUnit: e.maxPricePerUnit
  };
}
function Ae(e) {
  return Qs({ unit: e }) ? Fe : It;
}
function Xi(e, t, n = 2) {
  const a = BigInt(10 ** n), s = BigInt(Math.round(t * 10 ** n));
  return e * s / a;
}
const Zi = [Fe], sn = (e, t = ro) => {
  if (e.max && "amount" in e.max)
    return {
      ...e,
      ...e.max
    };
  const n = 10000n, { amount: a, pricePerUnit: s, dataGasConsumed: o = 0n, dataGasPrice: i = 0n } = e, c = a * s + o * i;
  if (c < 0)
    throw Error("Cannot calculate max fee for negative fee");
  const l = f.toBigInt(an({ estimatedFee: c })), d = Number(l) / Number(c), u = t(d), h = BigInt(Math.trunc(u * Number(n)));
  return {
    ...e,
    amount: a * h / n,
    pricePerUnit: s * h / n,
    dataGasConsumed: o * h / n,
    dataGasPrice: i * h / n
  };
}, oe = (e) => {
  const { amount: t, pricePerUnit: n, dataGasConsumed: a = 0n, dataGasPrice: s = 0n } = e;
  return t * n + a * s;
}, eo = (e) => {
  if (e.max)
    return "maxFee" in e.max ? e.max.maxFee : oe(e.max);
}, ke = (e) => {
  const t = eo(e);
  return t || oe(sn(e));
}, Qi = (e) => {
  if (e.deployment && !N(e.deployment.feeTokenAddress, e.transactions.feeTokenAddress))
    throw Error("Cannot calculate estimated fees for different tokens");
  const t = oe(e.transactions), n = e.deployment ? oe(e.deployment) : 0n;
  return t + n;
}, ec = (e) => {
  if (e.deployment && !N(e.deployment.feeTokenAddress, e.transactions.feeTokenAddress))
    throw Error("Cannot calculate estimated fees for different tokens");
  const t = e.deployment ? ke(e.deployment) : 0n, n = ke(e.transactions);
  return t + n;
}, tc = (e, t) => [
  {
    contractAddress: e,
    entrypoint: "transfer",
    calldata: O.compile(Tn.parse({
      // We are using a dummy address (ETH here) as recipient to estimate the fee given we don't have a receipient yet
      recipient: t,
      // We are using the smallest possible amount to make sure this doesn't throw an error
      amount: x.bnToUint256(BigInt(1))
    }))
  }
], to = (e, t) => {
  if (!e)
    return {
      transactions: {
        feeTokenAddress: t ?? It,
        amount: 0n,
        pricePerUnit: 0n,
        dataGasConsumed: 0n,
        dataGasPrice: 0n
      }
    };
  if (!Array.isArray(e))
    throw Error(`Unexpected simulation response. Expected array. Got ${typeof e}`);
  if (e.length === 1) {
    const n = Se.parse(e[0].feeEstimation);
    return {
      transactions: {
        feeTokenAddress: Ae(n.unit),
        amount: f.toBigInt(n.gasUsage),
        pricePerUnit: f.toBigInt(n.gasPrice),
        max: V(B(n, f.toBigInt)),
        dataGasConsumed: n.dataGasConsumed ? f.toBigInt(n.dataGasConsumed) : 0n,
        dataGasPrice: n.dataGasPrice ? f.toBigInt(n.dataGasPrice) : 0n
      }
    };
  }
  if (e.length === 2) {
    const n = Se.parse(e[0].feeEstimation), a = Se.parse(e[1].feeEstimation);
    return {
      deployment: {
        feeTokenAddress: Ae(n.unit),
        amount: f.toBigInt(n.gasUsage),
        pricePerUnit: f.toBigInt(n.gasPrice),
        max: V(B(n, f.toBigInt)),
        dataGasConsumed: n.dataGasConsumed ? f.toBigInt(n.dataGasConsumed) : 0n,
        dataGasPrice: n.dataGasPrice ? f.toBigInt(n.dataGasPrice) : 0n
      },
      transactions: {
        feeTokenAddress: Ae(a.unit),
        amount: f.toBigInt(a.gasUsage),
        pricePerUnit: f.toBigInt(a.gasPrice),
        max: V(B(a, f.toBigInt)),
        dataGasConsumed: a.dataGasConsumed ? f.toBigInt(a.dataGasConsumed) : 0n,
        dataGasPrice: a.dataGasPrice ? f.toBigInt(a.dataGasPrice) : 0n
      }
    };
  }
  throw Error("Unexpected simulation response length");
}, no = ({ transaction: e, nonce: t, chainId: n, version: a, isDeploymentTransaction: s, cairoVersion: o, address: i, appDomain: c }) => {
  let l = t;
  s && e.type !== "DEPLOY_ACCOUNT" && (l = f.toHex(1));
  const d = ie(e.calls);
  return {
    type: e.type,
    chainId: n,
    cairoVersion: o,
    nonce: l,
    version: a,
    account: i,
    calls: d,
    calldata: e.calldata,
    salt: e.salt,
    signature: e.signature,
    classHash: e.classHash,
    appDomain: c
    // appDomain: "https://starknetkit-blacked-listed.vercel.app", // to simulate blacklisted domain
  };
}, ao = (e, t) => {
  const { transactions: n } = e, a = n.map((l) => {
    if (!l.simulation)
      throw new Zs({ code: "SIMULATE_AND_REVIEW_FAILED" });
    return l;
  }), s = a.map((l) => ({
    ...l.simulation,
    feeEstimation: B(l.simulation.feeEstimation, Number)
  })), o = to(s, t), [i, c] = a.length === 1 ? [a[0], void 0] : [a[1], a[0]];
  return {
    ...o,
    transactions: {
      ...o.transactions,
      dataGasConsumed: o.transactions.dataGasConsumed ?? 0n,
      dataGasPrice: o.transactions.dataGasPrice ?? 0n,
      max: V(B(i.simulation.feeEstimation, f.toBigInt))
    },
    deployment: o.deployment && c ? {
      ...o.deployment,
      dataGasConsumed: o.deployment.dataGasConsumed ?? 0n,
      dataGasPrice: o.deployment.dataGasPrice ?? 0n,
      max: V(B(c.simulation.feeEstimation, f.toBigInt))
    } : void 0
  };
}, nc = (e) => {
  const t = sn(e), n = ke(e);
  return {
    // for v1 transactions
    maxFee: n,
    // for v3 transactions
    resourceBounds: {
      l1_gas: {
        // (overall_fee / gas_price) × gas_safety_margin
        max_amount: f.toHex(n / e.pricePerUnit),
        // max_price_per_unit: gas_price × fee_safety_margin
        max_price_per_unit: f.toHex(t.pricePerUnit)
      },
      l2_gas: {
        max_amount: "0x0",
        max_price_per_unit: "0x0"
      }
    }
  };
}, ac = (e) => {
  const t = Math.sqrt(e);
  return isNaN(t) ? Math.sqrt(2) : t;
}, ro = (e) => {
  const t = Math.cbrt(e);
  return isNaN(t) ? Math.cbrt(2) : t;
}, rc = (e) => e < 1 || isNaN(e) ? 1.1 : Math.log(e + 1) + 1, wt = {
  Transfer: Z.getSelectorFromName("Transfer"),
  // 0x99cd8bde557814842a3121e8ddfd433a539b8c9f14bf31ebf108d12e6196e9
  Approval: Z.getSelectorFromName("Approval")
  // 0x134692b230b9e1ffa39098904722134159652b09c5bc41d88d6698779d228ff
}, so = (e, t, n) => {
  for (const a of e) {
    const { events: s, internal_calls: o } = a;
    for (const i of s)
      for (const c of i.keys)
        c === wt.Approval && t.push({
          tokenAddress: y.parse(a.contract_address),
          owner: i.data[0],
          spender: i.data[1],
          value: x.uint256ToBN({ low: i.data[2], high: i.data[3] }).toString()
        }), c === wt.Transfer && n.push({
          tokenAddress: y.parse(a.contract_address),
          from: i.data[0],
          to: i.data[1],
          value: x.uint256ToBN({ low: i.data[2], high: i.data[3] }).toString()
        });
    o && so(o, t, n);
  }
  return { approvals: t, transfers: n };
}, oo = /(0x[a-fA-F0-9]+)\s*\('(.*?)'\)/, sc = (e) => {
  if (!Be(e))
    return;
  const t = e.match(oo);
  if (t && !Ce(t[2]))
    return t[2];
}, io = [Fe];
function ze({ address: e }) {
  return io.some((t) => N(e, t));
}
function oc(e) {
  return e ? pr().some((t) => N(t, e)) : !1;
}
function Tt(e) {
  return ze({
    address: e
  }) ? S.TRANSACTION_VERSION.V3 : S.TRANSACTION_VERSION.V1;
}
function ic(e) {
  return ze({ address: e }) ? S.TRANSACTION_VERSION.F3 : S.TRANSACTION_VERSION.F1;
}
function cc(e, t) {
  return In(t.contract) ? ze({ address: e }) ? S.TRANSACTION_VERSION.V3 : S.TRANSACTION_VERSION.V2 : S.TRANSACTION_VERSION.V1;
}
var Oe;
(function(e) {
  e.SIMULATE_AND_REVIEW_FAILED = "Something went wrong fetching review", e.NO_CALLS_FOUND = "No calls found", e.ONCHAIN_FEE_ESTIMATION_FAILED = "Failed to estimate fees onchain";
})(Oe || (Oe = {}));
class H extends Pe {
  constructor(t) {
    super(t, Oe), this.name = "ReviewError";
  }
}
class lc {
  constructor(t, n) {
    this.apiBase = t, this.httpService = n;
  }
  /**
   * Fetch transaction review labels
   * @returns {Promise<TransactionReviewLabel[] | undefined>} The account activities.
   */
  async getLabels() {
    const t = p(this.apiBase, "reviewer", "labels");
    return await this.httpService.get(t);
  }
  /**
   * Fetch transaction review warnings.
   * @returns {Promise<TransactionReviewWarning[] | undefined>} The account activities.
   */
  async getWarnings() {
    const t = p(this.apiBase, "reviewer", "warnings/reasons");
    return await this.httpService.get(t);
  }
  async simulateAndReview(t, n, a, s, o) {
    const i = n.some((c) => c.type === "DEPLOY_ACCOUNT");
    try {
      if (!("getChainId" in t))
        throw new Error("MISSING_METHOD");
      const c = Tt(a), l = i ? "0x0" : await t.getNonce(), d = await t.getChainId(), u = {
        transactions: n.map((C) => ({
          ...no({
            transaction: C,
            nonce: l,
            version: c,
            chainId: d,
            isDeploymentTransaction: i,
            appDomain: s,
            cairoVersion: t.cairoVersion,
            address: t.address
          }),
          type: C.type
        }))
      }, h = p(this.apiBase, "reviewer", "transactions", "v2", "review", "starknet"), m = await this.httpService.post(h, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(u)
      }, _n);
      if (m.transactions.some((C) => An(C)))
        return m;
      const E = ao(m, a);
      return {
        ...m,
        enrichedFeeEstimation: E
      };
    } catch (c) {
      return console.error(c), this.fallbackToOnchainFeeEstimation({
        transactions: n,
        account: t,
        isDeploymentTransaction: i,
        feeTokenAddress: a,
        accountDeployTransaction: o
      });
    }
  }
  getCallsFromTx(t) {
    let n;
    return t.calls && (n = ie(t.calls)), n;
  }
  async fallbackToOnchainFeeEstimation({ transactions: t, account: n, isDeploymentTransaction: a, feeTokenAddress: s, accountDeployTransaction: o }) {
    try {
      const i = a ? this.getCallsFromTx(t[1]) : this.getCallsFromTx(t[0]);
      if (!i)
        throw new H({
          code: "NO_CALLS_FOUND"
        });
      const c = await this.fetchFeesOnchain({
        starknetAccount: n,
        calls: i,
        isDeployed: !a,
        feeTokenAddress: s,
        accountDeployTransaction: o
      });
      return {
        transactions: [],
        enrichedFeeEstimation: c,
        isBackendDown: !0
      };
    } catch (i) {
      throw console.error(i), new H({
        message: `${i}`,
        code: "SIMULATE_AND_REVIEW_FAILED"
      });
    }
  }
  async fetchFeesOnchain({ starknetAccount: t, calls: n, isDeployed: a, feeTokenAddress: s, accountDeployTransaction: o }) {
    try {
      const i = Tt(s), c = {
        transactions: {
          feeTokenAddress: s,
          amount: 0n,
          pricePerUnit: 0n,
          dataGasConsumed: 0n,
          dataGasPrice: 0n
        }
      };
      if (!a && o) {
        if ("estimateFeeBulk" in t) {
          const l = [
            {
              type: nt.DEPLOY_ACCOUNT,
              payload: {
                classHash: o.classHash,
                addressSalt: o.salt,
                constructorCalldata: o.calldata,
                contractAddress: t.address
              }
            },
            {
              type: nt.INVOKE,
              payload: n
            }
          ], [d, u] = await t.estimateFeeBulk(l, {
            version: i
          }).catch((h) => {
            throw console.error(h), h;
          });
          if (!d.gas_consumed || !d.gas_price || !u.gas_consumed || !u.gas_price)
            throw new H({
              code: "ONCHAIN_FEE_ESTIMATION_FAILED",
              message: "Missing gas_consumed or gas_price"
            });
          c.deployment = {
            feeTokenAddress: s,
            amount: d.gas_consumed,
            pricePerUnit: d.gas_price,
            dataGasConsumed: d.data_gas_consumed,
            dataGasPrice: d.data_gas_price
          }, c.transactions = {
            feeTokenAddress: s,
            amount: u.gas_consumed,
            pricePerUnit: u.gas_price,
            dataGasConsumed: u.data_gas_consumed,
            dataGasPrice: u.data_gas_price
          };
        }
      } else {
        const { gas_consumed: l, gas_price: d, data_gas_consumed: u, data_gas_price: h } = await t.estimateFee(n, {
          skipValidate: !0,
          version: i
        });
        if (!l || !d)
          throw new H({
            code: "ONCHAIN_FEE_ESTIMATION_FAILED",
            message: "Missing gas_consumed or gas_price"
          });
        c.transactions = {
          feeTokenAddress: s,
          amount: l,
          pricePerUnit: d,
          dataGasConsumed: u,
          dataGasPrice: h
        };
      }
      return c;
    } catch (i) {
      throw new H({
        code: "ONCHAIN_FEE_ESTIMATION_FAILED",
        message: `${i}`
      });
    }
  }
}
const dc = r.object({
  reason: r.string(),
  severity: r.string().optional(),
  title: r.string(),
  description: r.string().optional()
}), uc = [
  "account-upgrade",
  "approve",
  "set-approval-for-all",
  "swap",
  "transfer"
], co = Object.values(S.TRANSACTION_VERSION), hc = r.string().default("0x3").refine((e) => {
  const t = f.toBigInt(e);
  return co.map((n) => f.toBigInt(n)).includes(t);
}).transform((e) => f.toHex(e));
function fc(e) {
  if (e === S.TRANSACTION_VERSION.V3 || e === S.TRANSACTION_VERSION.F3)
    throw Error("Only txv1 is supported");
}
const mc = (e) => ({ showBalanceChange: R(() => {
  const n = e == null ? void 0 : e.some((s) => !Ce(s.transfers)), a = e == null ? void 0 : e.some((s) => !Ce(s.approvals));
  return e && (n || a);
}, [e]) }), ge = (e) => e ? e.filter((t) => t.token.type === "erc20") : [], pc = (e) => R(() => ge(e), [e]), gc = (e) => ge(e).length > 0, bc = (e) => ge(e).some((n) => n.amount > 0n), yc = (e) => ge(e).some((n) => n.amount < 0n), on = (e) => e ? e.filter((t) => t.token.type === "erc721") : [], Sc = (e) => R(() => on(e), [e]), lo = (e) => on(e).length > 0, wc = (e) => R(() => lo(e), [e]), Tc = (e, t) => R(() => e && t ? [
  {
    contractAddress: e.address,
    entrypoint: "transfer",
    calldata: O.compile({
      recipient: t,
      amount: M(e.balance)
    })
  }
] : [], [e, t]), _c = ({ apiData: { apiBaseUrl: e, apiHeaders: t }, address: n, network: a, transactionReviewEnabled: s = !0, transactions: o }) => {
  const i = Nt(async () => {
    if (!n || !a)
      return;
    if (!e)
      throw "Transaction review endpoint is not defined";
    const l = p(e, "reviewer/transactions/review/starknet"), d = xn(o) ? o : [o], u = {
      network: a,
      account: n,
      calls: d
    };
    return Ot(l, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...t
      },
      body: JSON.stringify(u)
    });
  }, [n, a, o]), c = R(() => Pn({ transactions: o, address: n, network: a }), [o, n, a]);
  return $n(!!s, [c, "transactionReview"], i);
}, Ac = (e) => {
  if (!e)
    return {};
  const t = e.assessment === "warn" && e.reason !== "contract_is_not_verified", n = e.reason ? ` (Reason: ${Ct(e.reason)})` : "", a = t ? e.reason === "recipient_is_token_address" ? "You are sending tokens to their own address. This is likely to burn them." : `This transaction has been flagged as dangerous. We recommend you reject this transaction unless you are sure.${n}` : void 0;
  return {
    warn: t,
    reason: a
  };
}, uo = (e) => {
  var t;
  if (e) {
    for (const n of e.reviews)
      if (((t = n.activity) == null ? void 0 : t.type) === "swap")
        return n;
  }
}, vc = (e) => {
}, Ic = (e, t) => {
  var n;
  if (t) {
    for (const a of t.reviews)
      if (((n = a.activity) == null ? void 0 : n.type) === e)
        return a.activity;
  }
}, Ec = (e) => !!uo(e), Cc = (e) => {
  var t, n;
  if (e) {
    for (const a of e.reviews)
      if ((t = a.activity) != null && t.type)
        return {
          ...a,
          type: (n = a.activity) == null ? void 0 : n.type
        };
  }
}, ho = async ({ feeTokenAddress: e, calls: t, selectedAccount: n, transactionReviewService: a, appDomain: s, accountDeployTransaction: o }) => {
  const i = {
    type: "INVOKE",
    calls: ie(t)
  };
  if (!n || !e)
    return;
  const c = o ? [o, i] : [i];
  return { result: await a.simulateAndReview(n, c, e, s, o) };
}, fo = async (e, t, n, a) => {
  var m, g, E, C, ye, We;
  let s = !1;
  const o = t.transactions.find((A) => {
    var Ke, qe;
    return (qe = (Ke = A == null ? void 0 : A.simulation) == null ? void 0 : Ke.summary) == null ? void 0 : qe.find((ln) => ln.sent);
  });
  if (!o || !((m = o.simulation) != null && m.summary))
    return s;
  const i = o.simulation.summary.filter((A) => A.sent).map((A) => A.token.address);
  if (!(((g = t.enrichedFeeEstimation) == null ? void 0 : g.transactions.feeTokenAddress) && i.includes((E = t.enrichedFeeEstimation) == null ? void 0 : E.transactions.feeTokenAddress)) || !((ye = (C = t.enrichedFeeEstimation) == null ? void 0 : C.transactions) != null && ye.max))
    return s;
  const l = "amount" in t.enrichedFeeEstimation.transactions.max ? t.enrichedFeeEstimation.transactions.max.amount : "maxFee" in t.enrichedFeeEstimation.transactions.max ? t.enrichedFeeEstimation.transactions.max.maxFee : void 0, d = (We = o.simulation.summary.find((A) => A.sent && A.token.address === n)) == null ? void 0 : We.value;
  if (!l || !d)
    return s;
  const u = await Ts(n, e, a) ?? 0n;
  return BigInt(u) > l + BigInt(d) || (s = !0), s;
}, Nc = () => Nt(async ({ feeTokenAddress: t, calls: n, selectedAccount: a, transactionReviewService: s, appDomain: o, accountDeployPayload: i, provider: c }) => {
  if (!a)
    return;
  const l = await ho({
    feeTokenAddress: t,
    calls: n,
    selectedAccount: a,
    transactionReviewService: s,
    appDomain: o,
    accountDeployTransaction: mo(i)
  });
  if (!l || !l.result || !t)
    return;
  const d = await fo(a.address, l.result, t, c);
  return { ...l.result, isSendingMoreThanBalanceAndGas: d };
}, []), mo = (e) => e ? {
  type: "DEPLOY_ACCOUNT",
  calldata: e.calldata,
  classHash: X.parse(e.class_hash),
  salt: X.parse(e.salt),
  signature: []
} : void 0, xc = r.string().refine((e) => Fn(e, Bn), "Invalid seedphrase");
function kc(e, t) {
  const n = at(e), a = at();
  return Q(() => {
    n.current = e;
  }, [e]), Q(() => () => {
    a.current && clearTimeout(a.current);
  }, []), (...s) => {
    a.current && clearTimeout(a.current), a.current = setTimeout(() => n.current(...s), t);
  };
}
function Oc(e, t) {
  const [n, a] = kn(e);
  return Q(() => {
    const s = setTimeout(() => {
      a(e);
    }, t);
    return () => {
      clearTimeout(s);
    };
  }, [e, t]), n;
}
const po = r.object({
  name: r.enum([
    "dappland",
    "discord",
    "github",
    "telegram",
    "twitter",
    "website"
  ]),
  url: r.string(),
  position: r.number()
}), go = r.object({
  address: ce,
  chain: r.enum(["ethereum", "starknet"])
}), bo = r.object({
  dappId: r.string(),
  name: r.string(),
  description: r.string().optional(),
  logoUrl: r.string().optional(),
  dappUrl: r.string().optional(),
  inAppBrowserCompatible: r.boolean(),
  argentVerified: r.boolean(),
  links: r.array(po).optional(),
  contracts: r.array(go).optional(),
  categories: r.array(r.string()).optional(),
  supportedApps: r.array(r.string()).optional(),
  brandColor: r.string().optional()
}), yo = r.array(bo);
class Pc {
  constructor(t, n) {
    this.apiBase = t, this.httpService = new De(n, "json");
  }
  async getAll() {
    const t = await this.httpService.get(`${this.apiBase}/tokens/dapps`), n = yo.safeParse(t);
    if (!n.success)
      throw new Error("Failed to parse known dapps");
    return n.data;
  }
}
function So(e) {
  var t;
  return (t = e == null ? void 0 : e.links) == null ? void 0 : t.find((n) => n.name === "dappland");
}
function Fc(e) {
  var t;
  return (t = So(e)) == null ? void 0 : t.url;
}
const cn = b.object({
  domain: vn,
  address: y.optional(),
  avatar: b.string().optional(),
  status: b.union([b.literal("KNOWN"), b.literal("UNKNOWN")])
}), wo = b.array(cn), To = b.object({
  provider: b.string(),
  name: b.string(),
  avatar: b.string().optional()
}), _o = b.object({
  address: y,
  status: b.union([b.literal("KNOWN"), b.literal("UNKNOWN")]),
  resolutions: b.array(To).optional()
}), Ao = b.array(b.string()), vo = _o.array();
class Bc {
  constructor(t, n) {
    this.apiBase = t, this.headers = n, this.httpService = new De(this.headers, "json");
  }
  async getAddressFromMultipleStarknetId(t, n, a) {
    const s = new URLSearchParams(n.map((l) => ["domain", l]));
    a && s.set("includeAvatar", "true");
    const o = p(this.apiBase, t, "starknet.id", `?${s}`), i = await this.httpService.get(o), c = wo.safeParse(i);
    if (!c.success)
      throw new Error("Failed to parse name resolution");
    return c.data;
  }
  async getAddressFromStarknetId(t, n, a) {
    const s = p(this.apiBase, t, "starknet.id", n, a ? "?includeAvatar=true" : ""), o = await this.httpService.get(s), i = cn.safeParse(o);
    if (!i.success)
      throw new Error("Failed to parse name resolution");
    return i.data;
  }
  /**
   * getAddressFromStarknetId: retrieve address from starknetId
   */
  async getStarknetIdFromAddress(t, n, a) {
    const s = new URLSearchParams(n.map((l) => ["address", l]));
    a && s.set("includeAvatar", "true");
    const o = p(this.apiBase, t, "addresses", `?${s}`), i = await this.httpService.get(o), c = vo.safeParse(i);
    if (!c.success)
      throw new Error("Failed to parse name resolution");
    return c.data;
  }
  async getProvidersNames(t) {
    const n = p(this.apiBase, t, "providers", "name"), a = await this.httpService.get(n), s = Ao.safeParse(a);
    if (!s.success)
      throw new Error("Failed to parse name resolution");
    return s.data;
  }
}
async function Rc() {
  if ("brave" in navigator)
    try {
      return await navigator.brave.isBrave();
    } catch {
    }
  return !1;
}
let ve;
function Io() {
  return ve || (ve = new Rn(navigator.userAgent).getResult()), ve;
}
function be(e) {
  return Io().browser.name === e;
}
function Dc() {
  return be("Firefox");
}
function jc() {
  return be("Chrome");
}
function Uc() {
  return be("Safari");
}
function Lc() {
  return be("Edge");
}
export {
  I as ARGENT_ACCOUNT_CONTRACT_CLASS_HASHES,
  te as ARGENT_MULTISIG_CONTRACT_CLASS_HASHES,
  Lo as AddSmartAccountResponseSchema,
  Ho as AddSmartAcountRequestSchema,
  Un as BackendAccountSchema,
  Si as BackendNftService,
  Pe as BaseError,
  Yn as C0_PROXY_CONTRACT_CLASS_HASHES,
  Ii as CacheService,
  G as DEFAULT_TOKEN_DECIMALS,
  zo as DateService,
  xe as ESTIMATE_ERROR_MESSAGES,
  It as ETH_TOKEN_ADDRESS,
  Zs as EstimateError,
  $c as EventEmitterProvider,
  wt as EventsBySelector,
  nn as FEE_OVERHEAD,
  De as HTTPService,
  Ye as HTTP_ERROR_MESSAGE,
  T as HttpError,
  Pc as KnownDappsBackendService,
  Ze as MultiSigner,
  vs as PRETTY_UNLIMITED,
  Bc as ResolveNameService,
  bn as STANDARD_DEVNET_ACCOUNT_CLASS_HASH,
  Fe as STRK_TOKEN_ADDRESS,
  Wo as SWRService,
  Zo as StarknetAddressService,
  Ne as TOKEN_ERROR_MESSAGES,
  Mc as TXV1_ACCOUNT_CLASS_HASH,
  Gc as TXV1_MULTISIG_CLASS_HASH,
  zc as TXV3_ACCOUNT_CLASS_HASH,
  Wc as TXV3_MULTISIG_CLASS_HASH,
  Os as TokenError,
  Ui as TokenServiceWeb,
  lc as TransactionReviewServiceWeb,
  Kc as abiEntrySchema,
  qc as abiSchema,
  Yc as addOwnersCalldataSchema,
  Jc as addPluginCalldataSchema,
  Xc as addressInputCharactersAndLengthSchema,
  Zc as addressInputSchema,
  Qc as addressOrDomainInputSchema,
  el as addressOrDomainSchema,
  tl as addressOrEmptyUndefinedSchema,
  y as addressSchema,
  ce as addressSchemaArgentBackend,
  nl as addressSchemaBase,
  al as addressSchemaLooseLength,
  rl as addressSchemaStrictLength,
  Ws as airdropSchema,
  Ps as apiAccountTokenBalancesSchema,
  Ls as apiAirdropSchema,
  Xt as apiCollateralizedDebtPositionSchema,
  Di as apiCollateralizedDebtPositionsSchema,
  Jt as apiConcentratedLiquidityPositionSchema,
  Ri as apiConcentratedLiquidityPositionsSchema,
  Ds as apiDefiDecompositionProduct,
  Rs as apiDefiDecompositionProducts,
  js as apiDefiDecompositionSchema,
  yt as apiDefiDecompositionToken,
  Us as apiDefiPositionsSchema,
  Bi as apiPriceDataResponseSchema,
  qt as apiPriceDetailsSchema,
  Bs as apiTokenInfoResponseSchema,
  K as apiTokenInfoSchema,
  Fs as apiTokensInfoResponseSchema,
  uc as apiTransactionReviewActivityType,
  ji as apiUnclaimedRewardsSchema,
  sl as apiWalletResponseSchema,
  jn as argentBackendNetworkIdSchema,
  an as argentMaxFee,
  ol as argentNameSchema,
  Dn as argentNetworkIdSchema,
  fi as bigDecimal,
  il as bigNumberSchema,
  cl as bigNumberishSchema,
  ll as booleanToStringSchema,
  mo as buildAccountDeployTransaction,
  yr as buildConstructorCalldata,
  tc as buildDummyTx,
  dl as builtinsSchema,
  ul as byteCodeSchema,
  hl as cairo1EventSchema,
  fl as cairoAssemblySchema,
  ml as cairoVersionSchema,
  ro as calculateCubeRootAdjustment,
  rc as calculateNonLinearAdjustment,
  ac as calculateSqrtAdjustment,
  pl as callDetailsSchema,
  Ie as callSchema,
  gl as calldataSchema,
  B as castFeeEstimation,
  bl as changeGuardianCalldataSchema,
  yl as changeThresholdCalldataSchema,
  fo as checkGasFeeBalance,
  oc as classHashSupportsTxV3,
  Hi as collateralizedDebtGroupSchema,
  tn as collateralizedDebtPositionSchema,
  Vi as collateralizedDebtPositionsSchema,
  Sl as compiledContractClassSchema,
  wl as compiledSierraCasmSchema,
  Tl as compiledSierraSchema,
  _l as compressedProgramSchema,
  en as concentratedLiquidityPositionSchema,
  Li as concentratedLiquidityPositionsSchema,
  yn as constructorCallDataSchemaC0,
  Sn as constructorCallDataSchemaC1V1,
  Al as contractEntryPointFieldsSchema,
  xi as convertTokenAmountToCurrencyValue,
  ki as convertTokenUnitAmountWithDecimals,
  go as dappContractSchema,
  po as dappLinkSchema,
  ii as daysBetween,
  Xr as decodeBase58,
  oi as decodeBase58Array,
  $i as defiDappsProductsSchema,
  $s as defiPositionSchema,
  Kt as defiPositionTypeSchema,
  Gs as defiProductSchema,
  zs as defiProductsSchema,
  fc as denyTxV3,
  Jr as encodeBase58,
  si as encodeBase58Array,
  ie as ensureArray,
  Oi as ensureDecimals,
  gi as entryPointToHumanReadable,
  vl as entryPointsByTypeSchema,
  vi as equalNft,
  zi as erc20TransferTransaction,
  Ki as erc721SafeTransferFromTransaction,
  Wi as erc721TransferFromTransaction,
  Il as escapeGuardianCalldataSchema,
  ke as estimatedFeeToMaxFeeTotal,
  nc as estimatedFeeToMaxResourceBounds,
  oe as estimatedFeeToTotal,
  ec as estimatedFeesToMaxFeeTotal,
  Qi as estimatedFeesToTotal,
  El as eventAbiSchema,
  Cl as eventEntrySchema,
  Nl as executeOnPluginCalldataSchema,
  ze as feeTokenNeedsTxV3Support,
  xl as feltSchema,
  Ot as fetchData,
  ee as fetcherError,
  ai as findImplementationForAccount,
  so as findTransfersAndApprovals,
  Rt as formatAddress,
  kl as formatFullAddress,
  Ol as formatTruncatedAddress,
  Pl as formatTruncatedSignerKey,
  Fl as formatTruncatedString,
  Bl as functionAbiSchema,
  Rl as functionAbiTypeSchema,
  re as generateAvatarImage,
  Sr as getAccountContractAddress,
  br as getAccountDeploymentPayload,
  Yo as getAccountIdentifier,
  pn as getAddressFromArgentName,
  qn as getAddressFromStarkName,
  ot as getArgentAccountClassHashes,
  pr as getArgentAccountClassHashesWithTxV3Support,
  mr as getArgentAccountWithMultiSignerClassHashes,
  Xo as getBackendTimeNowSeconds,
  Mn as getBackendTimeSeconds,
  Kn as getCallFromStarkName,
  Gn as getChainIdFromNetworkId,
  qr as getColor,
  So as getDapplandLinkForDapp,
  Fc as getDapplandUrlForDapp,
  Ac as getDisplayWarnAndReasonForTransactionReview,
  ge as getERC20Transactions,
  on as getERC721Transactions,
  to as getEstimatedFeeFromBulkSimulation,
  ao as getEstimatedFeeFromSimulationAndRespectWatermarkFee,
  Wr as getInitials,
  ei as getLastCairo0ArgentAccountClassHash,
  fr as getLatestArgentAccountClassHash,
  Qo as getLatestArgentMultisigClassHash,
  ni as getLatestLedgerAccountClassHash,
  ti as getLedgerAccountClassHashes,
  qi as getMessageFromTrpcError,
  vc as getNFTTransferActivity,
  ri as getNetworkAccountImageUrl,
  Ai as getNftPicture,
  no as getPayloadFromTransaction,
  sc as getPrettyRpcError,
  ho as getReviewForTransactions,
  Xe as getSignerForMultiSigner,
  ic as getSimulationTxVersionFromFeeToken,
  Wn as getStarknetIdContractAddressFromNetworkId,
  Ts as getTokenBalance,
  Ci as getTokens,
  Ei as getTokensBalances,
  Ic as getTransactionReviewActivityOfType,
  Ec as getTransactionReviewHasSwap,
  uo as getTransactionReviewSwap,
  Cc as getTransactionReviewWithType,
  Tt as getTxVersionFromFeeToken,
  cc as getTxVersionFromFeeTokenForDeclareContract,
  Io as getUAParserResult,
  M as getUint256CalldataFromBN,
  eo as getWatermarkedMaxFeeTotal,
  gc as hasERC20Transactions,
  lo as hasERC721Transactions,
  bc as hasIncomingERC20Transactions,
  yc as hasOutgoingERC20Transactions,
  X as hexSchema,
  Dl as hexSchemaBase,
  Gr as id,
  Je as implementationSchema,
  jl as includesAddress,
  qs as inputAmountSchema,
  Mo as isAccountV4,
  $o as isAccountV5,
  Vo as isAccountV6,
  hn as isAddress,
  ui as isAllowedAddressHexInputValue,
  hi as isAllowedNumericInputValue,
  Uo as isArgentBackendNetworkId,
  mn as isArgentName,
  jo as isArgentNetworkId,
  Rc as isBraveBrowser,
  be as isBrowser,
  jc as isChromeBrowser,
  li as isContractDeployed,
  Lc as isEdgeBrowser,
  N as isEqualAddress,
  Ul as isEqualArgentName,
  gr as isEqualImplementation,
  Ll as isEqualStarknetDomainName,
  Hl as isEqualStarknetId,
  Qs as isFRI,
  ci as isFeatureEnabled,
  Dc as isFirefoxBrowser,
  _ as isNumeric,
  Uc as isSafariBrowser,
  Vl as isStarknetDomainName,
  fn as isStarknetId,
  As as isUnlimitedAmount,
  un as isValidAddress,
  Gi as isValidInputAmount,
  rn as isWEI,
  dn as isZeroAddress,
  bo as knownDappSchema,
  yo as knownDappsSchema,
  $l as legacyContractClassSchema,
  Ml as legacyEventSchema,
  Yi as modifySnjsFeeOverhead,
  Gl as multiTypeSchema,
  Xi as multiplyBigIntByFloat,
  To as nameProviderResolutionSchema,
  _o as nameResolutionAddressSchema,
  vo as nameResolutionAddressesSchema,
  cn as nameResolutionStarknetIdSchema,
  wo as nameResolutionStarknetIdsSchema,
  di as nonNullable,
  vt as normalizeAddress,
  zl as normalizeAddressOrDomain,
  Wl as normalizeArgentName,
  Kl as normalizeStarknetId,
  Ks as parseAmount,
  ys as parseAmountValue,
  mi as pluralise,
  Ko as postData,
  Go as preferencesEndpointPayload,
  Ln as preferencesSchema,
  Zr as prettifyCurrencyNumber,
  Pi as prettifyCurrencyValue,
  Vt as prettifyNumber,
  Le as prettifyNumberConfig,
  Fi as prettifyTokenAmount,
  Qr as prettifyTokenNumber,
  Ms as productGroupsSchema,
  ql as programSchema,
  Ao as providersNamesSchema,
  Yl as pythonicHintsSchema,
  Jl as rawArgsArraySchema,
  Xl as rawArgsObjectSchema,
  Zl as rawArgsSchema,
  pi as readFileAsString,
  Ql as removeOwnersCalldataSchema,
  ed as removePluginCalldataSchema,
  td as replaceSignerCalldataSchema,
  xc as seedphraseSchema,
  nd as sierraContractEntryPointFieldsSchema,
  ad as sierraEntryPointsByTypeSchema,
  rd as sierraProgramDebugInfoSchema,
  zn as starkNameToCallDataDomain,
  sd as starknetDomainNameSchema,
  vn as starknetIdSchema,
  od as stringToBooleanSchema,
  Yr as stripAddressZeroPadding,
  id as structAbiSchema,
  Jo as swrRefetchDisabledConfig,
  V as toMax,
  Zi as tokensRequireTxV3Support,
  Ji as transactionReviewTransactionsSchema,
  dc as transactionReviewWarningSchema,
  Tn as transferCalldataSchema,
  Ys as trpcErrorSchema,
  hc as txVersionSchema,
  cd as uint256Schema,
  Mi as unclaimedRewardsSchema,
  Ae as unitToFeeTokenAddress,
  bi as urlWithQuery,
  mc as useBalanceChange,
  Ti as useCollection,
  $n as useConditionallyEnabledSWR,
  kc as useDebounce,
  Oc as useDebouncedValue,
  pc as useERC20Transactions,
  Sc as useERC721Transactions,
  ld as useEmitEvent,
  dd as useEventEmitter,
  ud as useEventEmitterContext,
  hd as useEventListener,
  wc as useHasERC721Transaction,
  fd as useIsEventEmitterEnabled,
  Tc as useMaxAmountTransaction,
  _i as useNft,
  wi as useNfts,
  Ni as useToken,
  _c as useTransactionReview,
  Nc as useTransactionReviewV2webFetcher,
  md as validChecksumAddressSchema,
  pd as validateAddressRangeSchema,
  yi as voidify,
  qo as withPolling
};
